/** @module IglooAdZone **/

/**
 * Exports the IglooAdZone public functions
 * @param  {Igloo}   igloo    The igloo module
 * @param  {Integer} igloo_id The igloo ID
 * @return {Object}           The public properties for the class:
 * [productConfig]{@link module:IglooAdZone~product_query} and
 * [rotateAd]{@link module:IglooAdZone~rotate_ad}
 */
module.exports = function(igloo, igloo_id, presets, is_test) {
  /*jshint maxcomplexity:14 */
  'use strict';
  var embedId = igloo.utils.guid();

  var prebidSource = '//content.predictinteractive.com/prebid.js';

  /**
   * Constants
   */
  var BIDDER_PREDICT = 'predict';
  var BIDDER_ONEWORLD = 'oneworld';
  var BIDDER_ADSENSE = 'passback_adsense';
  var BIDDER_ADSTERRA = 'passback_adsterra';
  // vuukle
  var VUUKLE_ARCAMAX = '3ji2ue';
  var VUUKLE_ARCAMAX_WEBSITE = 'kuqbku';
  var VUUKLE_PARTNER_MAP = {
    VUUKLE_ALLHIPHOP: {
      id: 'cu935w',
    },
    VUUKLE_RIVERFRONT: {
      id: 'fjpbcn',
    },
    VUUKLE_SACURRENT: {
      id: 'hu3x49',
    },
    VUUKLE_ARCAMAX: {
      id: VUUKLE_ARCAMAX,
    },
    VUUKLE_ARCAMAX_WEBSITE: {
      id: VUUKLE_ARCAMAX_WEBSITE,
      gptId: 'div-gpt-ad-1497448474263-4',
    },
    VUUKLE_CENTIPEDE: {
      id: 'y8zmfb',
    },
    VUUKLE_CENTIPEDE_2_TEST: {
      id: 'g0zpkj',
    },
    VUUKLE_ALLHIPHOP_CENTIPEDE_2: {
      id: 'd1567e',
    },
    VUUKLE_RIVERFRONT_CENTIPEDE_2: {
      id: 'whgn50',
    },
    VUUKLE_SACURRENT_CENTIPEDE_2: {
      id: '4htvi7',
    },
    VUUKLE_MP1ST: {
      id: 'tzfsaw',
    },
    VUUKLE_RCFA: {
      id: 'ig0375',
    },
    VUUKLE_ENTERTAINMENT_FOCUS: {
      id: 'w9bjpy',
    },
    VUUKLE_INVEN_GLOBAL: {
      id: '3qa9fd',
    },
    VUUKLE_DAILY_GAZZETTE: {
      id: 'xvkig4',
    },
    VUUKLE_SPORTSMOLE: {
      id: 'cr460w',
    },
    VUUKLE_THE_HAY_RIDE: {
      id: '88tnsw',
    },
  };
  var VUUKLE_PARTNER_MAP_ARRAY = Object.values(VUUKLE_PARTNER_MAP);
  var VUUKLE_NONPARTNER_MAP = {
    VUUKLE_INQUIRER: 'y4msq4',
    VUUKLE_TPM: '7qugp8',
    VUUKLE_DRUDGE: 'b0xdfe',
    VUUKLE_TPM_CENTIPEDE: 'uipth0',

  };
  var VUUKLE_NONPARTNER_MAP_ARRAY = Object.values(VUUKLE_NONPARTNER_MAP);
  // didna
  var DIDNA_AUID_TRIVIA_300_600 = 'trivia_300_600';
  var DIDNA_AUID_TRIVIA_RESPONSIVE = 'trivia_responsive';
  var DIDNA_MAP = {
    DIDNA_TEST_PLACEMENT_HUSKERMAX_ID: {
      id: 'sw4vn6',
      path: '/170737076/didna_test',
      site: 'test',
      auid: DIDNA_AUID_TRIVIA_300_600,
    },
    BIG_BLUE_BANTER: {
      id: '9rmy1f',
      path: '/170737076/display/predictinteractive.com/bigbluebanter.com',
      site: 'bigbluebanter.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'bigbluebanter',
    },
    BIG_BLUE_BANTER_970_250: {
      id: '1eh7s6',
      path: '/170737076/display/predictinteractive.com/bigbluebanter.com',
      site: 'bigbluebanter.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'bigbluebanter',
    },
    CLEMSON_SPORTS_TALK: {
      id: 'g02yqd',
      path: '/170737076/display/predictinteractive.com/clemsonsportstalk.com',
      site: 'clemsonsportstalk.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'clemsonsportstalk',
    },
    CLEMSON_SPORTS_TALK_970_250: {
      id: 'llc6iw',
      path: '/170737076/display/predictinteractive.com/clemsonsportstalk.com',
      site: 'clemsonsportstalk.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'clemsonsportstalk',
    },
    DAWG_POST: {
      id: 'gx27nc',
      path: '/170737076/display/predictinteractive.com/dawgpost.com',
      site: 'dawgpost.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'dawgpost',
    },
    DAWG_POST_970_250: {
      id: '2n3ic2',
      path: '/170737076/display/predictinteractive.com/dawgpost.com',
      site: 'dawgpost.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'dawgpost',
    },
    INSIDE_PACK_SPORTS: {
      id: '06v78c',
      path: '/170737076/display/predictinteractive.com/insidepacksports.com',
      site: 'insidepacksports.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'insidepacksports',
    },
    INSIDE_PACK_SPORTS_970_250: {
      id: '2myxsy',
      path: '/170737076/display/predictinteractive.com/insidepacksports.com',
      site: 'insidepacksports.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'insidepacksports',
    },
    INSIDE_THE_GATORS: {
      id: '6rwdhr',
      path: '/170737076/display/predictinteractive.com/insidethegators.com',
      site: 'insidethegators.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'insidethegators',
    },
    INSIDE_THE_GATORS_970_250: {
      id: 'lzx3ps',
      path: '/170737076/display/predictinteractive.com/insidethegators.com',
      site: 'insidethegators.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'insidethegators',
    },
    IRISH_SPORTS_DAILY: {
      id: 'ju8zzb',
      path: '/170737076/display/predictinteractive.com/irishsportsdaily.com',
      site: 'irishsportsdaily.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'irishsportsdaily',
    },
    IRISH_SPORTS_DAILY_970_250: {
      id: '71jnag',
      path: '/170737076/display/predictinteractive.com/irishsportsdaily.com',
      site: 'irishsportsdaily.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'irishsportsdaily',
    },
    MY_BCS_SPORTS: {
      id: '6tafm8',
      path: '/170737076/display/predictinteractive.com/mybcssports.com',
      site: 'mybcssports.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'mybcssports',
    },
    MY_BCS_SPORTS_970_250: {
      id: '2057qg',
      path: '/170737076/display/predictinteractive.com/mybcssports.com',
      site: 'mybcssports.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'mybcssports',
    },
    POKES_REPORT: {
      id: 'uta1kp',
      path: '/170737076/display/predictinteractive.com/pokesreport.com',
      site: 'pokesreport.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'pokesreport',
    },
    POKES_REPORT_970_250: {
      id: 'ufjndw',
      path: '/170737076/display/predictinteractive.com/pokesreport.com',
      site: 'pokesreport.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'pokesreport',
    },
    SCOOP_DUCK: {
      id: 'ww1bez',
      path: '/170737076/display/predictinteractive.com/scoopduck.com',
      site: 'scoopduck.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'scoopduck',
    },
    SCOOP_DUCK_970_250: {
      id: 'f8lseb',
      path: '/170737076/display/predictinteractive.com/scoopduck.com',
      site: 'scoopduck.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'scoopduck',
    },
    SFA_SAWMILL: {
      id: 'z1f0sy',
      path: '/170737076/display/predictinteractive.com/sfasawmill.com',
      site: 'sfasawmill.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'sfasawmill',
    },
    SFA_SAWMILL_970_250: {
      id: 'ap9cpx',
      path: '/170737076/display/predictinteractive.com/sfasawmill.com',
      site: 'sfasawmill.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'sfasawmill',
    },
    SICEM_365: {
      id: 'dmp4ru',
      path: '/170737076/display/predictinteractive.com/sicem365.com',
      site: 'sicem365.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'sicem365',
    },
    SICEM_365_970_250: {
      id: 'i5k1ax',
      path: '/170737076/display/predictinteractive.com/sicem365.com',
      site: 'sicem365.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'sicem365',
    },
    TERRAPIN_TIMES: {
      id: 'bjbdk0',
      path: '/170737076/display/predictinteractive.com/terrapintimes.com',
      site: 'terrapintimes.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'terrapintimes',
    },
    TERRAPIN_TIMES_970_250: {
      id: '4klp4v',
      path: '/170737076/display/predictinteractive.com/terrapintimes.com',
      site: 'terrapintimes.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'terrapintimes',
    },
    TEXAGS: {
      id: 'ghz0cd',
      path: '/170737076/display/predictinteractive.com/texags.com',
      site: 'texags.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'texags',
    },
    TEXAGS_970_250: {
      id: '6p8rgt',
      path: '/170737076/display/predictinteractive.com/texags.com',
      site: 'texags.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'texags',
    },
    TIGER_BAIT: {
      id: 'flsf1k',
      path: '/170737076/display/predictinteractive.com/tigerbait.com',
      site: 'tigerbait.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'tigerbait',

    },
    TIGER_BAIT_970_250: {
      id: '0s8thw',
      path: '/170737076/display/predictinteractive.com/tigerbait.com',
      site: 'tigerbait.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'tigerbait',
    },
    USC_SCOOP: {
      id: 'cuvtxc',
      path: '/170737076/display/predictinteractive.com/uscscoop.com',
      site: 'uscscoop.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'uscscoop',
    },
    USC_SCOOP_970_250: {
      id: '8ck5d6',
      path: '/170737076/display/predictinteractive.com/uscscoop.com',
      site: 'uscscoop.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'uscscoop',
    },
    ALWAYS_RACE_DAY: {
      id: 'p43kbs',
      path: '/170737076/display/predictinteractive.com/alwaysraceday.com',
      site: 'alwaysraceday.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'alwaysraceday',
    },
    ALWAYS_RACE_DAY_970_250: {
      id: 'ik8dg1',
      path: '/170737076/display/predictinteractive.com/alwaysraceday.com',
      site: 'alwaysraceday.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'alwaysraceday',
    },
    BEAR_INSIDER: {
      id: 'vy1xc1',
      path: '/170737076/display/predictinteractive.com/bearinsider.com',
      site: 'bearinsider.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'bearinsider',
    },
    BEAR_INSIDER_970_250: {
      id: 'nc52i4',
      path: '/170737076/display/predictinteractive.com/bearinsider.com',
      site: 'bearinsider.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'bearinsider',
    },
    CYCLONE_FANATIC: {
      id: 'lves3u',
      path: '/170737076/display/predictinteractive.com/cyclonefanatic.com',
      site: 'cyclonefanatic.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'cyclonefanatic',
    },
    CYCLONE_FANATIC_970_250: {
      id: 'ic1mwx',
      path: '/170737076/display/predictinteractive.com/cyclonefanatic.com',
      site: 'cyclonefanatic.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'cyclonefanatic',
    },
    GOPHER_HOLE: {
      id: 'ksrfxx',
      path: '/170737076/display/predictinteractive.com/gopherhole.com',
      site: 'gopherhole.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'gopherhole',
    },
    GOPHER_HOLE_970_250: {
      id: 'ejdqk4',
      path: '/170737076/display/predictinteractive.com/gopherhole.com',
      site: 'gopherhole.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'gopherhole',
    },
    HAWK_EYE_NATION: {
      id: 'qidu3q',
      path: '/170737076/display/predictinteractive.com/hawkeyenation.com',
      site: 'hawkeyenation.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'hawkeyenation',
    },
    HAWK_EYE_NATION_970_250: {
      id: 'a58443',
      path: '/170737076/display/predictinteractive.com/hawkeyenation.com',
      site: 'hawkeyenation.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'hawkeyenation',
    },
    HEART_LAND_COLLEGE_SPORTS: {
      id: 'qr1vb5',
      path: '/170737076/display/predictinteractive.com/heartlandcollegesports.com',
      site: 'heartlandcollegesports.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'heartlandcollegesports',
    },
    HEART_LAND_COLLEGE_SPORTS_970_250: {
      id: '3497sz',
      path: '/170737076/display/predictinteractive.com/heartlandcollegesports.com',
      site: 'heartlandcollegesports.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'heartlandcollegesports',
    },
    HUSKER_BOARD: {
      id: 'vbb2me',
      path: '/170737076/display/predictinteractive.com/huskerboard.com',
      site: 'huskerboard.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'huskerboard',
    },
    HUSKER_BOARD_970_250: {
      id: 'w80yx0',
      path: '/170737076/display/predictinteractive.com/huskerboard.com',
      site: 'huskerboard.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'huskerboard',
    },
    HUSKER_MAX: {
      id: 'l63ykg',
      path: '/170737076/display/predictinteractive.com/huskermax.com',
      site: 'huskermax.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'huskermax',
    },
    HUSKER_MAX_970_250: {
      id: 'u4lhcn',
      path: '/170737076/display/predictinteractive.com/huskermax.com',
      site: 'huskermax.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'huskermax',
    },
    KILLER_FROGS: {
      id: 'xbik0b',
      path: '/170737076/display/predictinteractive.com/killerfrogs.com',
      site: 'killerfrogs.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'killerfrogs',
    },
    KILLER_FROGS_970_250: {
      id: '3nvgxi',
      path: '/170737076/display/predictinteractive.com/killerfrogs.com',
      site: 'killerfrogs.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'killerfrogs',
    },
    MGO_BLOG: {
      id: 'fppde0',
      path: '/170737076/display/predictinteractive.com/mgoblog.com',
      site: 'mgoblog.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'mgoblog',
    },
    MGO_BLOG_970_250: {
      id: 'pf87nk',
      path: '/170737076/display/predictinteractive.com/mgoblog.com',
      site: 'mgoblog.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'mgoblog',
    },
    ND_NATION: {
      id: 'uw8zyu',
      path: '/170737076/display/predictinteractive.com/ndnation.com',
      site: 'ndnation.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'ndnation',
    },
    ND_NATION_970_250: {
      id: 'bz3w5e',
      path: '/170737076/display/predictinteractive.com/ndnation.com',
      site: 'ndnation.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'ndnation',
    },
    UHND: {
      id: 'e3r8g2',
      path: '/170737076/display/predictinteractive.com/uhnd.com',
      site: 'uhnd.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'uhnd',
    },
    UHND_970_250: {
      id: 'jk7sq0',
      path: '/170737076/display/predictinteractive.com/uhnd.com',
      site: 'uhnd.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'uhnd',
    },
    VARSITY_BOUND: {
      id: 'dzfb7c',
      path: '/170737076/display/predictinteractive.com/varsitybound.com',
      site: 'varsitybound.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'varsitybound',
    },
    VARSITY_BOUND_970_250: {
      id: 'fbgbs2',
      path: '/170737076/display/predictinteractive.com/varsitybound.com',
      site: 'varsitybound.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'varsitybound',
    },
    WEARESC: {
      id: 'm0vizn',
      path: '/170737076/display/predictinteractive.com/wearesc.com',
      site: 'wearesc.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'wearesc',
    },
    WEARESC_970_250: {
      id: 'yewh0v',
      path: '/170737076/display/predictinteractive.com/wearesc.com',
      site: 'wearesc.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'wearesc',
    },
    FACESOFGAMING: {
      id: 'xg9p9e',
      path: '/170737076/display/predictinteractive.com/facesofgaming.com',
      site: 'facesofgaming.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'facesofgaming',
    },
    FACESOFGAMING_970_250: {
      id: 'p8m4ui',
      path: '/170737076/display/predictinteractive.com/facesofgaming.com',
      site: 'facesofgaming.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'facesofgaming',
    },
    USSSABASEBALL: {
      id: 'pszmxw',
      path: '/170737076/display/predictinteractive.com/usssabaseball.org',
      site: 'usssabaseball.org',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'usssabaseball',
    },
    USSSABASEBALL_970_250: {
      id: 'jtzr24',
      path: '/170737076/display/predictinteractive.com/usssabaseball.org',
      site: 'usssabaseball.org',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'usssabaseball',
    },
    HOCKEYDB: {
      id: 'l53vuz',
      path: '/170737076/display/predictinteractive.com/hockeydb.com',
      site: 'hockeydb.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'hockeydb',
    },
    HOCKEYDB_970_250: {
      id: 'evv7m3',
      path: '/170737076/display/predictinteractive.com/hockeydb.com',
      site: 'hockeydb.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'hockeydb',
    },
    GON: {
      id: 'nwaxmz',
      path: '/170737076/display/predictinteractive.com/gon.com',
      site: 'gon.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'gon',
    },
    GON_970_250: {
      id: '7bn8c8',
      path: '/170737076/display/predictinteractive.com/gon.com',
      site: 'gon.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'gon',
    },
    BASEBALLPEDIA: {
      id: '1ecrrq',
      path: '/170737076/display/predictinteractive.com/baseballpedia.com',
      site: 'baseballpedia.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'baseballpedia',
    },
    BASEBALLPEDIA_970_250: {
      id: '9d9nay',
      path: '/170737076/display/predictinteractive.com/baseballpedia.com',
      site: 'baseballpedia.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'baseballpedia',
    },
    SHORTSTORY: {
      id: '1mmhn9',
      path: '/170737076/display/predictinteractive.com/short-story.me',
      site: 'short-story.me',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'short-story',
    },
    SHORTSTORY_970_250: {
      id: 'tcuh2y',
      path: '/170737076/display/predictinteractive.com/short-story.me',
      site: 'short-story.me',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'short-story',
    },
    MUSCLECARSANDTRUCKS: {
      id: 'q852tp',
      path: '/170737076/display/predictinteractive.com/musclecarsandtrucks.com',
      site: 'musclecarsandtrucks.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'musclecarsandtrucks',
    },
    MUSCLECARSANDTRUCKS_970_250: {
      id: '78gc8b',
      path: '/170737076/display/predictinteractive.com/musclecarsandtrucks.com',
      site: 'musclecarsandtrucks.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'musclecarsandtrucks',
    },
    CLASSMENTPOC: {
      id: 'zjf7my',
      path: '/170737076/display/predictinteractive.com/classementpoc.com',
      site: 'classementpoc.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'classementpoc',
    },
    CLASSMENTPOC_970_250: {
      id: '8iywh9',
      path: '/170737076/display/predictinteractive.com/classementpoc.com',
      site: 'classementpoc.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'classementpoc',
    },
    EDGEGAMERS: {
      id: 'aet7px',
      path: '/170737076/display/predictinteractive.com/edgegamers.com',
      site: 'edgegamers.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'edgegamers',
    },
    EDGEGAMERS_970_250: {
      id: 'teb1zz',
      path: '/170737076/display/predictinteractive.com/edgegamers.com',
      site: 'edgegamers.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'edgegamers',
    },
    CANNABISEXAMINERS: {
      id: '1lbrk8',
      path: '/170737076/display/predictinteractive.com/cannabisexaminers.com',
      site: 'cannabisexaminers.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      placementSite: 'cannabisexaminers',
    },
    CANNABISEXAMINERS_970_250: {
      id: 'f1zmp8',
      path: '/170737076/display/predictinteractive.com/cannabisexaminers.com',
      site: 'cannabisexaminers.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      placementSite: 'cannabisexaminers',
    },
    REALGM_300_600: {
      id: 'u39h0x',
      path: '/170737076/display/predictinteractive.com/realgm.com',
      site: 'predictinteractive.realgm.com',
      auid: DIDNA_AUID_TRIVIA_300_600,
      bidders: {
        '300x250': {
          'sovrn': { tagid: '645987' },
          'onemobile': { dcn: '8a9691d0017070401401403a11d30006', pos: '8a9698ab01747406698907d5067700f3' },
        },
        'sizeless': {
          'appnexus': { placementId: '23087066' },
          '33across': { siteId: 'dVaqIEv0Cr66eeaKj0P0Le', productId: 'siab' },
          'amx': { tagId: 'ZGlkbmEuaW8', 'adUnitId': 'predictinteractive.realgm.com' },
          'pubmatic': { publisherId: '159745', adSlot: '4105885' },
        },
      },
      placementSite: 'realgm',
    },
    REALGM_970_250: {
      id: '68ivv9',
      path: '/170737076/display/predictinteractive.com/realgm.com',
      site: 'predictinteractive.realgm.com',
      auid: DIDNA_AUID_TRIVIA_RESPONSIVE,
      bidders: {
        '300x250': {
          'sovrn': { tagid: '645987' },
          'onemobile': { dcn: '8a9691d0017070401401403a11d30006', pos: '8a9698ab01747406698907d5067700f3' },
        },
        'sizeless': {
          'appnexus': { placementId: '23087066' },
          '33across': { siteId: 'dVaqIEv0Cr66eeaKj0P0Le', productId: 'siab' },
          'amx': { tagId: 'ZGlkbmEuaW8', 'adUnitId': 'predictinteractive.realgm.com' },
          'pubmatic': { publisherId: '159745', adSlot: '4105885' },
        },
      },
      placementSite: 'realgm',
    },
  };
  var DIDNA_MAP_ARRAY = Object.values(DIDNA_MAP);
  // sovrn gold
  var SOVRN_GOLD_MAP = {
    SOVRN_GOLD_TEST: {
      id: 'jdrg9k',
      oneTagId: 'a8ca31f8-ab60-48c8-afed-ae362ffd2df3',
      layout: 'universal',
      divClass: 'samsad-predICTinteractive_RealGM_300x250',
    },
    SOVRN_GOLD_REALGM: {
      id: 'qcpy4s',
      oneTagId: 'a8ca31f8-ab60-48c8-afed-ae362ffd2df3',
      layout: 'universal',
      divClass: 'samsad-predICTinteractive_RealGM_300x250',
    },
    SOVRN_GOLD_REALGM_970x250: {
      id: 'cljibt',
      oneTagId: '99fa99cb-8616-4fe1-83d7-b5fdf2678b71',
      layout: '',
      divClass: 'samsad-predICTinteractive_300x250_nineseventyrealgm',
    },
    SOVRN_GOLD_REALGM_300x250: {
      id: 'g3rykp',
      oneTagId: '99fa99cb-8616-4fe1-83d7-b5fdf2678b71',
      layout: '',
      divClass: 'samsad-predICTinteractive_320x50_threehundreedrealgm',
    }
  };
  var SOVRN_GOLD_MAP_ARRAY = Object.values(SOVRN_GOLD_MAP);

  // vdo
  var VDO_AI_MAP = {
    TEST: '7n5iv8',
  };
  var VDO_AI_MAP_ARRAY = Object.values(VDO_AI_MAP);

  // millenium
  var MILLENIUM_MAP = {
    TEST: 'r8rnvu',
  };
  var MILLENIUM_MAP_ARRAY = Object.values(MILLENIUM_MAP);

  /**
   * Boolean that switches certain behavior for tests
   * @type {Boolean}
   */
  if (typeof is_test === 'undefined') {
    is_test = false;
  }

  /**** CONSTANTS ****/

  /**
   * The logger for the ad zone
   * @type {module:IglooLogger}
   */
  var log = require('./IglooLogger')(igloo, 'PREDICT Zone ' + igloo_id);
  /**
   * The URLs that can be used as the background image for the unit
   * @type {Object}
   */
  var local_host_image = '//image.predictinteractive.com';
  // disabled for now. mediaforce passback has a transparent background
  var bg_urls = { // jshint ignore:line
    '300x250': [
      [
        local_host_image + '/passbacks/300x250/PBA_Airplane-Window_V1-01.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Airplane-Window_V1-02.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Airplane-Window_V1-03.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Glasses-Blurred-BG-01.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Glasses-Blurred-BG-02.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Glasses-Blurred-BG-03.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Submarine-Window_V1-01.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Submarine-Window_V1-02.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Submarine-Window_V1-03.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Submarine-Window_V2-01.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Submarine-Window_V2-02.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
      [
        local_host_image + '/passbacks/300x250/PBA_Submarine-Window_V2-03.jpg',
        'http://predictinteractive.com/',
        'none',
      ],
    ]
  };

  /**** CONTROL VARIABLES ****/

  /**
   * The ad tags as broken out by platform
   * @type {Object}
   */
  var platform_ad_tags = presets[1];
  /**
   * This variable contains all data that is saved into memcached and the raw
   * data that is pulled from the que
   * @type {Object}
   */
  var query_configuration = {
    raw: get_query_parameters(presets[0], is_test),
    saved: presets[0],
  };

  /**
   * Determine if embed is product only.
   * @type {Boolean}
   */
  var isProductOnlyEmbed = query_configuration.saved.adH === 0 && query_configuration.saved.adW === 0;

  var isVuuklePartnerEmbed = (VUUKLE_PARTNER_MAP_ARRAY).findIndex(function(item) {
    return item.id === query_configuration.saved.z;
   }) !== -1;
  
  var isVuukleNonPartnerEmbed = (VUUKLE_NONPARTNER_MAP_ARRAY).indexOf(query_configuration.saved.z) !== -1;

  /**
   * Determine if embed is a vuukle test placement.
   * @type {Boolean}
   */
  var isVuukleTestEmbed = isVuuklePartnerEmbed || isVuukleNonPartnerEmbed;
  /**
   * Determine if embed is a didna test placement.
   * @type {Boolean}
   */
  var isDidnaTestEmbed = (DIDNA_MAP_ARRAY).findIndex(function(item) {
    return item.id === query_configuration.saved.z;
  }) !== -1;
  /**
   * Determine if embed is sovrn gold placement.
   * @type {Boolean}
   */
  var isSovrnGoldEmbed = (SOVRN_GOLD_MAP_ARRAY).findIndex(function(item) {
    return item.id === query_configuration.saved.z;
  }) !== -1;
  /**
   * Determine if embed is vdo ai placement.
   * @type {Boolean}
   */
  var isVdoAiEmbed = (VDO_AI_MAP_ARRAY).indexOf(query_configuration.saved.z) !== -1;
  /**
   * Determine if embed is millenium placement.
   */
  var isMilleniumEmbed = (MILLENIUM_MAP_ARRAY).indexOf(query_configuration.saved.z) !== -1;

  /**
   * This variable contains all of the HTML divs that are used
   * @type {Object}
   */
  var html_elements = {
    /**
     * The HTML Element that contains the entire product
     * @type {DOMElement}
     */
    container: null,
    /**
     * The pink div that highlights the product for easy identification when
     * debugging is enabled
     * @type {DOMElement}
     */
    outline_div: null,
    /**
     * The current advertisement's iframe
     * @type {DOMElement}
     */
    ad_iframe: null,
    /**
     * The next advertisement's iframe
     * @type {DOMElement}
     */
    ad_iframe_new: null,
    /**
     * The item to insert the product next to
     * @type {DOMElement}
     */
    insertion_location: get_insertion_location(query_configuration, is_test),
    /**
     * The product element
     * @type {DOMElement}
     */
    product: null,
    /**
     * The div that contains the advertisement iframes and debugging divs
     * @type {DOMElement}
     */
    top_ad_iframe: null,
    /**
     * The div that contains an appnexus video ad
     * @type {DOMElement}
     */
    appnexus_div: null,
    /**
     * The iframe for the didna code
     * @type {DOMElement}
     */
    didna_iframe: null,
    /**
     * The ad div for the didna code
     * @type {DOMElement}
     */
    didna_ad_div: null,
    /**
     * The ad div for the vuukle code
     * @type {DOMElement}
     */
    vuukle_ad_div: null,
    /**
     * The iframe for the non vuukle partner code
     * @type {DOMElement}
     */
    vuukle_iframe: null,
    /**
     * The ad div for the sovrn gold code
     * @type {DOMElement}
     */
    sovrn_gold_ad_div: null,
    /**
     * The iframe for the vdoai code
     * @type {DOMElement}
     */
    vdoai_iframe: null,
    /**
     * The divs that are used for debugging
     * @type {Object}
     */
    debug_divs: {
      iz: document.createElement('div'), // Igloo Zone ID
      vi: document.createElement('div'), // Visibility
      cpm: document.createElement('div'), // Estimated CPM
      pa: document.createElement('div'), // Paused/Running
      tr: document.createElement('div'), // Time remaining
      te: document.createElement('div'), // Time elapsed
      ap: document.createElement('div'), // Ad Provider
    },
  };
  /**
   * The configuration options for the product
   * @type {Object}
   */
  var product_configuration = presets[2];
  /**
   * This object contains the configuration options for the ad unit
   * @type {Object}
   */
  var ad_unit_configuration = {
    /**
     * This is the item that is passed into Prebid
     * @type {Object}
     */
    ad_unit: {
      code: 'igloo_' + igloo_id,
      mediaTypes: {
          banner: {
              sizes: [
                [
                  query_configuration.saved.adW,
                  query_configuration.saved.adH
                ]
              ]
          },
          video: {
            playerSize: [
              query_configuration.saved.adW,
              query_configuration.saved.adH,
            ],
            mimes: [
              'video/mp4',
              'video/x-flv'
            ],
            protocols: [2, 3],
            context: 'outstream'
          }
      },
      bids: [],
      break_even: 2,
      revenue: 0,
    },
    /**
     * This contains the configuration for each ad provider
     * @type {Object}
     */
    ad_provider_config: {
      adblade: {
        keys: ['partnerid', 'at_id'],
        tag: {},
      },
      appnexus: {
        keys: ['placementid'],
        tag: {},
      },
      brealtime: {
        net: 0.8,
        keys: ['unitid'],
        tag: {},
      },
      cox: {
        ucb: true,
        floor: 'floor',
        setPrice: 'finalizeAd',
        keys: ['zoneid', 'siteid'],
        tag: {},
      },
      nativeads_prebid: {
        keys: ['pbzoneid'],
        tag: {},
      },
      oath: {
        keys: ['placementid', 'networkid'],
        tag: {},
      },
      openx: {
        keys: ['unit'],
        bid: {
          bidder: 'openx',
          rv: 'off',
        },
        tag: {},
      },
      pulsepoint: {
        keys: ['cf', 'cp', 'ct'],
        tag: {},
      },
      realvu: {
        net: 0.85,
        keys: ['placementid', 'clientid', 'sizeid'],
        tag: {},
      },
      rubicon: {
        net: 0.8,
        keys: ['rpsite', 'rpzonesize', 'keyword'],
        tag: {},
      },
      sovrn: {
        keys: ['zoneid'],
        tag: {},
      },
      springserve: {
        keys: ['placementid'],
        tag: {},
      },
      adyoulike: {
        keys: ['placement'],
        tag: {}
      },
      '33across': {
        keys: ['siteid', 'productid'],
        tag: {}
      },
      gumgum: {
        net: 0.75,
        keys: ['inslot'],
        tag: {}
      },
      fidelity: {
        net: 0.7,
        keys: ['zoneid'],
        tag: {}
      },
      waardex: {
        keys: ['placementid'],
        tag: {}
      },
      nobid: {
        keys: ['siteid'],
        tag: {}
      },
      smartyads: {
        keys: ['placementid'],
        tag: {}
      },
      /**
       * 1world demand providers
       */
      '1w_adyoulike': {
        keys: ['placement'],
        tag: {}
      },
      '1w_fidelity': {
        net: 0.6,
        keys: ['zoneid'],
        tag: {}
      },
      '1w_smartyads': {
        keys: ['placementid'],
        tag: {}
      },
      '1w_conversant': {
        keys: ['siteid'],
        tag: {}
      },
      'emx_digital': {
        keys: ['tagid'],
        tag: {}
      },
      'sharethrough': {
        keys: ['pkey'],
        tag: {}
      },
      '1w_gumgum': {
        net: 0.75,
        keys: ['inslot'],
        tag: {}
      },
      '1w_152media': {
        keys: ['placementid'],
        tag: {}
      },
      '1w_pubmatic': {
        net: 0.75,
        keys: ['publisherid', 'adslot'],
        tag: {}
      },
      '1w_openx': {
        net: 0.75,
        keys: ['deldomain', 'unit'],
        tag: {}
      },
      /**
       * end 1world demand providers
       */
      oneworld: {
        keys: ['adauctionid, adunitid'],
        tag: {}
      },
      passback_adsense: {
        keys: ['dataadslot'],
        tag: {}
      },
      passback_adsterra: {
        keys: ['key'],
        tag: {}
      },
      passback_mediaforce: {
        keys: ['placementid'],
        tag: {}
      },
      predict: {
        keys: [],
        tag: {},
      },
      error: {
        timing: 5000,
      },
    },
    /**
     * The last observed debugging state (used for keeping track of which divs
     * to display)
     * @type {Boolean}
     */
    last_debug_state: false,
    /**
     * Used to determine whether to send visibility events
     * @type {Boolean}
     */
    product_was_visible: false,
    /**
     * Used to determine whether the widget has been intereacetd with
     * @type {Boolean}
     */
    product_has_been_interacted: false,
    /**
     * The object returned by the timing module
     * @type {Object}
     */
    timer: null,
    /**
     * The currently being loaded or displayed bid
     * @type {Object}
     */
    top_bid: null,
    /**
     * The default length of ads
     * @type {Integer}
     */
    standard_timing: presets[3],
  };

  /**** HTML CREATION FUNCTIONS ****/

  /**
   * Builds out all of the HTML elements required for the current embed. This
   * function also creates a pageview event if needed.
   * @param {Object} platform_ad_tags      The ad tags separated by platform
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} product_configuration The configuration options for the
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function build_unit(platform_ad_tags, query_configuration, html_elements, product_configuration, ad_unit_configuration) {
    /*jshint maxcomplexity:false*/
    log.trace('build_unit', arguments);
    send_events(query_configuration);

    // Create the container and append
    html_elements.container = document.createElement('div');

    var widgetIsDynamicWidth = typeof query_configuration.saved.dynamic_size !== 'undefined';

    igloo.utils.setElementAttributes(html_elements.container, {
      igloo_id: igloo_id,
      style: {
        width: widgetIsDynamicWidth
          ? '100%'
          // TODO - determine if this should be widW (widget width)
          : (parseInt(query_configuration.saved.adOffX) + parseInt(query_configuration.saved.adW)) + 'px',
        'max-width': widgetIsDynamicWidth
          ? '970px'
          : undefined,
        display: widgetIsDynamicWidth
          ? 'flex'
          : 'block',
        'justify-content': widgetIsDynamicWidth
          ? 'flex-start'
          : undefined,
        position: 'relative',
        color: '#000',
        float: 'none',
        margin: '0 auto',
        'line-height': 0,
      },
    });
    html_elements.insertion_location.parentElement.insertBefore(html_elements.container, html_elements.insertion_location);

    // Create an outline div
    html_elements.outline_div = document.createElement('div');
    igloo.utils.setElementAttributes(html_elements.outline_div, {
      style: {
        display: 'none',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        'z-index': 10,
        'pointer-events': 'none',
        border: '5px solid #F0F',
        'box-sizing': 'border-box',
        '-moz-box-sizing': 'border-box',
        '-webkit-box-sizing': 'border-box',
      },
    });
    html_elements.container.appendChild(html_elements.outline_div);

    get_ad_config(platform_ad_tags, query_configuration, ad_unit_configuration);
    
    // If unit is specific placement, build Didna test unit
    if (isDidnaTestEmbed) {
      try {
        build_didna_zone(html_elements, query_configuration, ad_unit_configuration);
      } catch (e) {
        log.error('Error Building Didna Unit', e);
      }
    }
    // If unit is specified placement, build Vuukle test unit
    else if (isVuuklePartnerEmbed && query_configuration.saved.adW > 0 && query_configuration.saved.adH > 0) {
      try {
        build_vuukle_zone(html_elements);
      } catch (e) {
        log.error('Error Building Vuukle Unit', e);
      }
    }
    else if (isVuukleNonPartnerEmbed && query_configuration.saved.adW > 0 && query_configuration.saved.adH > 0) {
      try {
        build_non_vuukle_partner_zone(html_elements, query_configuration);
      } catch (e) {
        log.error('Error Building Non Vuukle Partner Unit', e);
      }
    }
    else if (isSovrnGoldEmbed) {
      try {
        build_sovrn_gold_zone(html_elements, query_configuration);
      } catch (e) {
        log.error('Error Building Sovrn Gold Unit', e);
      }
    }
    else if(isVdoAiEmbed && query_configuration.saved.adW > 0 && query_configuration.saved.adH > 0) {
      try {
        build_vdoai_zone(html_elements, query_configuration, ad_unit_configuration);
      } catch (e) {
        log.error('Error Building VDO AI Unit', e);
      }
    }
    else if (isMilleniumEmbed && query_configuration.saved.adW > 0 && query_configuration.saved.adH > 0) {
      try {
        build_millenium_zone(html_elements);
      } catch (e) {
        log.error('Error Building Millenium Unit', e);
      }
    }
    // Else if placement has ad, add an ad zone
    else if (query_configuration.saved.adW > 0 && query_configuration.saved.adH > 0) {
      try {
        build_ad_zone(query_configuration, html_elements, ad_unit_configuration);

        // load prebid
        var prebidScript = html_elements.top_ad_iframe.contentDocument.createElement('script');
        prebidScript.type = 'text/javascript';
        prebidScript.async = true;
        prebidScript.src = prebidSource;
        var headerEl = html_elements.top_ad_iframe.contentDocument.getElementsByTagName('head')[0];
        headerEl.appendChild(prebidScript);

        prebidScript.addEventListener('load', function () {
          var iframeWindow = html_elements.top_ad_iframe.contentWindow;
          iframeWindow.pbjs.setConfig({
            userSync: {
              aliasSyncEnabled: true, // enable alias sync
              iframeEnabled: true,
              syncsPerBidder: 8,
              filterSettings: {
                iframe: {
                  bidders: '*',
                  filter: 'include'
                },
                image: {
                  bidders: '*',
                  filter: 'include'
                }
              }
            }
          });

          iframeWindow.pbjs.aliasBidder('adyoulike', '1w_adyoulike');
          iframeWindow.pbjs.aliasBidder('fidelity', '1w_fidelity');
          iframeWindow.pbjs.aliasBidder('smartyads', '1w_smartyads');
          iframeWindow.pbjs.aliasBidder('conversant', '1w_conversant');
          iframeWindow.pbjs.aliasBidder('pubmatic', '1w_pubmatic');
          iframeWindow.pbjs.aliasBidder('appnexus', '1w_152media');
          iframeWindow.pbjs.aliasBidder('openx', '1w_openx');
          iframeWindow.pbjs.aliasBidder('adkernel', 'waardex');

          iframeWindow.pbjs.que.push(
            enable_ad_unit.bind(
              undefined,
              query_configuration,
              html_elements,
              ad_unit_configuration
            )
          );
          // process prebid queue
          iframeWindow.pbjs.processQueue();
        });
      } catch (e) {
        log.error('Error Building Ad Zone', e);
      }
    } else {
      igloo.timer.registerFunction(check_debug.bind(undefined, html_elements, ad_unit_configuration));
    }

    // Build the product second
    if (
      (query_configuration.saved.widW > 0 && query_configuration.saved.widH > 0 && product_configuration.pr_injection_style !== null) ||
      product_configuration.pr_injection_style === 'script' ||
      (query_configuration.saved.type === 'double_decker' && query_configuration.saved.type_raw === 'double_decker')
    ) {
      try {
        build_product_zone(query_configuration, html_elements, product_configuration);
      } catch (e) {
        log.error('Error Building Product', e);
      }
    }
  } // --> build_unit

  /**
   * Send the pageview and widget embed events (if needed)
   * @param  {Object}  query_configuration The saved and raw query parameters
   * @return {Integer}                     The number of events sent (0-2)
   */
  function send_events(query_configuration) {
    log.trace('send_events', arguments);
    var event_count = 0;

    // Send a pageview event (if needed)
    if (igloo.tracker_called.indexOf(query_configuration.saved.p_id) === -1) {
      // Set the flag
      igloo.tracker_called.push(query_configuration.saved.p_id);

      // Add a pageview event
      igloo.tracker.addEvent({
        e: 'pageview',
        p: query_configuration.saved.p_id,
      });
      event_count++;
    }

    // TODO - remove vuukle test embed condition after test run
    // Create the widget event (if needed)
    if (typeof query_configuration.raw.event === 'undefined') {
      igloo.tracker.addEvent({
        e: 'widget',
        p: query_configuration.saved.p_id,
        w: typeof query_configuration.saved.type !== 'undefined' ? query_configuration.saved.type : 'UNKNOWN',
        z: query_configuration.saved.z,
      });
      event_count++;
    }

    return event_count;
  } // --> send_events

  /**
   * Builds out the product iframe
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} product_configuration The configuration options for the
   *                                       product
   */
  function build_product_zone(query_configuration, html_elements, product_configuration) {
    log.trace('build_product_zone', arguments);

    // Check for the double decker
    if (query_configuration.saved.type === 'double_decker') {
      // Build the script tag
      html_elements.product = document.createElement('script');
      var product_location = document.createElement('span');

      // Build the query
      var double_decker_query = igloo.utils.objectAssign({}, query_configuration.raw, {
        event: 0,
        widW: 0,
        type: 'inline_ad',
        json: true,
      });

      // Add that to the que
      var que_item = {
        div: product_location,
        id: igloo.top.igloo_que.length,
        win: get_product_window(query_configuration),
        ig_query: double_decker_query,
      };
      igloo.top.igloo_que.push(que_item);
      double_decker_query.que_id = que_item.id;

      // Set the attributes of the script tag
      igloo.utils.setElementAttributes(html_elements.product, {
        id: 'div_pfwidget_' + query_configuration.saved.type + '_' + Math.ceil(Math.random() * 0x100000).toString(16).substring(1),
        src: '//content.predictinteractive.com/l/n/igloo.php?' + Object.keys(double_decker_query).map(function(key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(double_decker_query[key]);
          }).join('&'),
        async: 'true',
        igloo_id: igloo_id,
      });

      // Append the script tag
      igloo.top.document.body.appendChild(html_elements.product);
      html_elements.container.appendChild(product_location);
      var space_div = document.createElement('div');
      igloo.utils.setElementAttributes(space_div, {
        role: 'spacer',
        style: {
          width: '300px',
          height: '100px',
        },
      });

      html_elements.container.appendChild(space_div);
    } else {
      // Create the event portion
      product_configuration.base_query.event = {
        p: query_configuration.saved.p_id,
        w: query_configuration.saved.type,
        z: query_configuration.saved.z,
        igloo_id: igloo_id,
      };

      // Create and append the product
      build_product_element(query_configuration, html_elements, product_configuration);
    }
  } // --> build_product_zone

  /**
   * Build the HTML element that contains the product
   * @param  {Object}  query_configuration   The saved and raw query parameters
   * @param  {Object}  html_elements         The HTML items for the ad zone
   * @param  {Object}  product_configuration The configuration options for the
   *                                         product
   * @return {Boolean}                       True if an element was embedded,
   *                                         false otherwise
   */
  function build_product_element(query_configuration, html_elements, product_configuration) {
    /*jshint maxcomplexity:18 */
    log.trace('build_product_element', arguments);

    switch (product_configuration.pr_injection_style) {
      case 'iframe':
        html_elements.product = document.createElement('iframe');
        igloo.utils.setElementAttributes(html_elements.product, {
          src: product_configuration.pr_url + '?' + JSON.stringify(product_configuration.base_query),
          id: 'div_pfwidget_' + query_configuration.saved.type + '_' + Math.ceil(Math.random() * 0x100000).toString(16).substring(1),
          scrolling: 'no',
          igloo_id: igloo_id,
          style: {
            width: typeof query_configuration.saved.dynamic_size !== 'undefined' ? 'calc(100% - ' + query_configuration.saved.adW + 'px)' : query_configuration.saved.widW + 'px',
            height: query_configuration.saved.widH + 'px',
            display: 'block',
            position: 'relative',
            margin: 0,
            'margin-left': query_configuration.saved.widOffX + 'px',
            'margin-top': query_configuration.saved.widOffY + 'px',
            float: 'none',
            outline: 'none',
            border: 'none'
          },
        });

        // set an interval that checks the ad dimensions
        if (typeof query_configuration.saved.d_resize !== 'undefined' && typeof query_configuration.saved.dynamic_size === 'undefined') {
          igloo.timer.registerFunction(function() {
            if (typeof query_configuration.saved.d_resize !== 'undefined') {
              var parentWidth = igloo.top.innerWidth;
              if (parentWidth > 970) {
                parentWidth = 970;
              }
              var productWidth = parentWidth - 300;
              if (parentWidth < 650) {
                productWidth = 0;
              }
              query_configuration.saved.widW = productWidth;
            }
            // Check the width
            if (html_elements.product.clientWidth !== query_configuration.saved.widW) {
              igloo.utils.setElementAttributes(html_elements.product, {
                style: {
                  width: query_configuration.saved.widW + 'px'
                }
              });
            }
            // Check the height
            if (html_elements.product.clientHeight !== query_configuration.saved.widH) {
              igloo.utils.setElementAttributes(html_elements.product, {
                style: {
                  height: query_configuration.saved.widH + 'px'
                }
              });
            }
          });
        }

        html_elements.container.prepend(html_elements.product);
        break;
      case 'script':
        // Add the script parameters
        product_configuration.base_query.wide = typeof query_configuration.saved.dynamic_size !== 'undefined'
          ? true
          : false;
        product_configuration.base_query.style = query_configuration.saved.style;

        // PALTALK WEBSITE HARDCODE A/B TEST
        if (product_configuration.base_query.z === 'uv2b15') {
          var randomPaltalkWebsite = Math.random();
          product_configuration.base_query.group = randomPaltalkWebsite < 0.5
            ? 'music'
            : 'music';
          product_configuration.base_query.category = randomPaltalkWebsite < 0.5
            ? 'boy_bands'
            : 'bands';
        }

        var widgetIsDynamicWidth = typeof query_configuration.saved.dynamic_size !== 'undefined';
        var productDivStyle = widgetIsDynamicWidth
          ? {
            width: 'calc(100% - 300px)',
            height: '250px',
            display: 'block',
          }
          : {
            display: 'block',
          };
        
        var productDiv = document.createElement('div');
        igloo.utils.setElementAttributes(productDiv, {
          style: productDivStyle,
        });
        html_elements.container.prepend(productDiv);

        // register time function if product is dynamic width
        if (widgetIsDynamicWidth) {
          igloo.timer.registerFunction(function() {
            if (typeof query_configuration.saved.dynamic_size !== 'undefined') {
              var containerWidth = html_elements.container.offsetWidth;
              if (containerWidth >= 640) {
                igloo.utils.setElementAttributes(productDiv, {
                  style: {
                    display: 'block',
                  },
                });
              } else {
                igloo.utils.setElementAttributes(productDiv, {
                  style: {
                    display: 'none',
                  },
                });
              }
            }
          });
        }

        // Build the script
        html_elements.product = document.createElement('script');
        igloo.utils.setElementAttributes(html_elements.product, {
          src: product_configuration.pr_url + '?' + JSON.stringify(product_configuration.base_query),
          id: 'div_pfwidget_' + query_configuration.saved.type + '_' + Math.ceil(Math.random() * 0x100000).toString(16).substring(1),
          igloo_id: igloo_id,
        });

        productDiv.prepend(html_elements.product);
        break;
      case 'vue':
        html_elements.product = document.createElement('iframe');

        // Set the styles of the ad div
        igloo.utils.setElementAttributes(html_elements.product, {
          id: ad_unit_configuration.ad_unit.code + '_igloo_product_iframe',
          src: 'about:blank',
          scrolling: 'no',
          frameBorder: 0,
          allowTransparency: 'true',
          sandbox: 'allow-forms allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation',
          style: {
            width: query_configuration.saved.widW + 'px',
            height: query_configuration.saved.widH + 'px',
            margin: 0,
          },
        });
        html_elements.container.prepend(html_elements.product);

        if (isVuuklePartnerEmbed) {
          product_configuration.base_query.vuukle = true;
        }

        html_elements.product.contentWindow.PREDICT_CONFIG = product_configuration.base_query;

        var baseUrl = product_configuration.pr_url;

        // assign div id that the widget will use
        product_configuration.base_query.id = 'predict_widget';

        // load widget
        html_elements.product.contentDocument.open();
        html_elements.product.contentDocument.write(`
          <div id="${product_configuration.base_query.id}"></div>
          <link rel="stylesheet" href="${baseUrl}app.css">
          <script src="${baseUrl}app.js"></script>
          <script src="${baseUrl}chunk-vendors.js"></script>
        `);
        html_elements.product.contentDocument.close();

        // remove margin from document body
        html_elements.product.contentDocument.body.style.margin = 0;
        break;
      case null:
        log.warn('No Product Rendering');
        return false;
      default:
        log.error('Invalid Injection Type: ', product_configuration.pr_injection_style);
        return false;
    }
    return true;
  } // --> build_product_element

  /**
   * Builds out the ad div
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function build_ad_zone(query_configuration, html_elements, ad_unit_configuration) {
    log.trace('build_ad_zone', arguments);

    // Create the ad iframe
    html_elements.top_ad_iframe = document.createElement('iframe');
    
    // Set the styles of the ad div
    igloo.utils.setElementAttributes(html_elements.top_ad_iframe, {
      class: 'widget_zone',
      id: ad_unit_configuration.ad_unit.code + '_iframe',
      igloo_id: igloo_id,
      src: 'about:blank',
      scrolling: 'no',
      frameBorder: 0,
      allowTransparency: 'true',
      sandbox: 'allow-forms allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation',
      style: {
        width: query_configuration.saved.adW + 'px',
        height: query_configuration.saved.adH + 'px',
        margin: 0,
        'margin-left': query_configuration.saved.adOffX + 'px',
        'margin-top': query_configuration.saved.adOffY + 'px',
      },
    });

    // Add some special styles if its dynamic
    if (typeof query_configuration.saved.dynamic_size !== 'undefined') {
      igloo.utils.setElementAttributes(html_elements.top_ad_iframe, {
        style: {
          'margin-left': 0,
          'margin-top': 0,
        },
      });
      igloo.utils.setElementAttributes(html_elements.container, {
        style: {
          height: query_configuration.saved.adH + 'px',
        },
      });
    }

    // Append the ad div
    html_elements.container.appendChild(html_elements.top_ad_iframe);

    build_debug_divs(query_configuration, html_elements, ad_unit_configuration);

    // Set iframe body styles
    igloo.utils.setElementAttributes(html_elements.top_ad_iframe.contentDocument.body, {
      style: {
        margin: 0,
      },
    });
  } // --> build_ad_zone

  /**
   * Builds out the ad div for a didna unit
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} ad_unit_configuration The configuration object for the ad unit
   */
  function build_didna_zone(html_elements, query_configuration, ad_unit_configuration) {
    // The default styles for the ad iframe
    var ad_ifr_style = {
      width: query_configuration.saved.adW + 'px',
      height: query_configuration.saved.adH + 'px',
      margin: '0px',
    };
    html_elements.didna_iframe = document.createElement('iframe');
    igloo.utils.setElementAttributes(html_elements.didna_iframe, {
      id: 'DIDNAIFR_' + ad_unit_configuration.ad_unit.code,
      scrolling: 'no',
      frameBorder: 0,
      allowTransparency: 'true',
      sandbox: 'allow-forms allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox',
      style: ad_ifr_style,
    });
    // Append the didna iframe
    html_elements.container.appendChild(html_elements.didna_iframe);

    var didnaDocument = html_elements.didna_iframe.contentDocument;

    var bidders = {};
    ad_unit_configuration.ad_unit.bids.forEach(function (item) {
      // filter out predict bidder
      if (!bidders.hasOwnProperty(item.bidder) && item.bidder !== 'predict') {
        bidders[item.bidder] = item.params;
      }
    });

    var didnaParams = (DIDNA_MAP_ARRAY).find(function(item) {
      return item.id === query_configuration.saved.z;
    });

    var isSiteSpecificPlacement = !!(didnaParams && didnaParams.placementSite);

    // injecting script through document.write
    var biddersJson = didnaParams.bidders
      ? JSON.stringify(didnaParams.bidders)
      : JSON.stringify({
        '300x250': bidders
      });
    html_elements.didna_iframe.contentDocument.write(`
      <div id="ad-script">
        <script>
          var DIDNA_CONFIG = {
            'headerBidding': 1,
            'manualMode': true,
            'enableRulesEngine': false,
            'didnaTrackers': false,
            'logging': false,
            'activeTab': true,
            'lazyload': ${didnaParams && didnaParams.placementSite === 'realgm' ? 0 : 1},
            'lazyloadConfig': {
              'desktop': {
                'rootMargin': '80% 0px'
              },
              'mobile': {
                'rootMargin': '80% 0px'
              }
            },
            'prebidConfig': {
              'version': '${prebidSource}',
              'inject': true,
              'options': {
                'bidderTimeout': 2000,
                'priceGranularity': 'high',
                'userSync': {
                  'syncDelay': 3000
                },
                'publisherDomain': '${igloo.top.location.hostname}',
              }
            },
            'startUpConfig': {
              'desktopTimeout': 0,
              'mobileTimeout': 0
            },
            'factoryConfig': {
              'all': {
                'inViewRefresh': 15000,
                'refresh': 900000,
                'timelaps': 7500,
                'delay': 7500,
                'canIbv': true
              }
            },
            'ibv': true,
            'ibvConfig': {
              'firstLoad': true,
              'ibvWaitCount': 2,
              'url': 'https://pubads.g.doubleclick.net/gampad/ads?iu=/170737076/IBV/predictinteractive.com/${didnaParams.site}&description_url=https%3A%2F%2F'+window.location.hostname+'&env=vp&impl=s&correlator=&tfcd=0&npa=0&gdfp_req=1&output=xml_vast4&sz=640x480&max_ad_duration=30000&unviewed_position_start=1'
            },
            'scanners': {
              'confiant': {
                'prebid': 1
              },
              'devcon': {
                'page': 0
              }
            },
            'setupConfig': {
              'outOfViewRefresh': false
            },
            'placements': {
              ${isSiteSpecificPlacement
                ? `
                'all': {},
                 '${didnaParams.placementSite}': ${biddersJson}
                `
                : `
                'all': ${biddersJson}
              `}
              
            }
          };
      
          (function(){
            let duEL = document.createElement("script");
            duEL.type = "text/javascript";
            duEL.async = true;
            duEL.src = "https://storage.googleapis.com/didna-prod/didna_util_v3.15.1.min.js.gz";
            let duTargetEl = document.getElementsByTagName("head")[0];
            duTargetEl.appendChild(duEL);
          })();
      
          var didna = window.didna||{};
          didna.cmd = didna.cmd||[];
          didna.cmd.push(function(){
            var adUnits = [{
                adUnitPath: '${ didnaParams ? didnaParams.path : '/170737076/didna_test' }',
                id: 'predict_rectangle',
                size: [300,250],
                targeting: {
                  auid: '${ didnaParams && didnaParams.auid ? didnaParams.auid : DIDNA_AUID_TRIVIA_300_600 }',
                },
              }];
            didna.createAdUnits(adUnits);
          });
        </script>
      </div>
      <div id='predict_rectangle' style="width:300px;height:250px"></div>
    `);

    // remove margin from body of iframe
    didnaDocument.body.style.margin = '0';
  } // --> build_didna_zone

  /**
   * Builds out the sovrn gold unit
   * @param {Object} html_elements 
   * @param {Object} query_configuration   The saved and raw query parameters
   */
  function build_sovrn_gold_zone(html_elements, query_configuration) {
    html_elements.sovrn_gold_ad_div = document.createElement('div');


    var sovrnGoldParams = (SOVRN_GOLD_MAP_ARRAY).find(function(item) {
      return item.id === query_configuration.saved.z;
    });

    // Set the styles of the ad div
    igloo.utils.setElementAttributes(html_elements.sovrn_gold_ad_div, {
      class: sovrnGoldParams.divClass,
    });

    // Append the ad div
    html_elements.container.appendChild(html_elements.sovrn_gold_ad_div);

    var sovrnGoldDocument = html_elements.sovrn_gold_ad_div.ownerDocument;
    var sovrnGoldWindow = sovrnGoldDocument.defaultView;

    var scriptOneTag = document.createElement('script');
    scriptOneTag.src = `https://get.s-onetag.com/${sovrnGoldParams.oneTagId}/tag.min.js`;
    scriptOneTag.async = true;
    scriptOneTag.defer = true;
    html_elements.container.appendChild(scriptOneTag);

    var scriptMain = document.createElement('script');
    scriptMain.src = 'https://cdn.sovrnservices.com/v3/realgm.com/samsbid.js';
    html_elements.container.appendChild(scriptMain);

    sovrnGoldWindow.samsbid = sovrnGoldWindow.samsbid || {};
    sovrnGoldWindow.samsbid.cmd = sovrnGoldWindow.samsbid.cmd || [];
    sovrnGoldWindow.samsbid.cmd.push(function() {
      sovrnGoldWindow.samsbid.layout(sovrnGoldParams.layout);
      sovrnGoldWindow.samsbid.setTargeting('is_testing', 'no'); // Set to "no" for production
      var isHome = igloo.top.location
        && igloo.top.location.hostname === 'basketball.realgm.com'
        && igloo.top.location.pathname === '/';
      sovrnGoldWindow.samsbid.setTargeting('is_home', isHome ? 'yes' : 'no'); // Set to "yes" on the homepage
    });
  } // --> build_sovrn_gold_zone

  /**
   * Builds out the ad div for the vuukle unit
   * @param {Object} html_elements         The HTML items for the ad zone
   */
  function build_vuukle_zone(html_elements) {
    // Create the ad div
    html_elements.vuukle_ad_div = document.createElement('div');

    var vuukleParams = (VUUKLE_PARTNER_MAP_ARRAY).find(function(item) {
      return item.id === query_configuration.saved.z;
    });

    const vuukleDivId = vuukleParams.gptId
      ? vuukleParams.gptId
      : 'div-gpt-ad-1497448474263-3'; // default

    // Set the styles of the ad div
    igloo.utils.setElementAttributes(html_elements.vuukle_ad_div, {
      id: vuukleDivId,
    });

    // Append the ad div
    html_elements.container.appendChild(html_elements.vuukle_ad_div);

    var vuukleDocument = html_elements.vuukle_ad_div.ownerDocument;
    var vuukleWindow = vuukleDocument.defaultView;

    if (!vuukleWindow.vuukleLoaded) {
      try {
        vuukleWindow.top.vuukleLoader();
        vuukleWindow.vuukleLoaded = 1;
      } catch (e) {}
    }
    if (!vuukleWindow.vuuklePlayerComponent && !vuukleWindow.vuukleLoaded) {
      vuukleWindow.vuukleLoaded = 1;
      var e = vuukleDocument.createElement('script');
      e.type = 'text/javascript';
      e.src = 'https://cdn.vuukle.com/static/prebid3.js';
      (vuukleDocument.head || vuukleDocument.documentElement).appendChild(e);
    }
    vuukleWindow.vuuklehb = vuukleWindow.vuuklehb || {};
    vuukleWindow.vuuklehb.que = vuukleWindow.vuuklehb.que || [];
    vuukleWindow.vuuklehb.que.push(function() {
      if (vuukleWindow.vuuklehb.vInitSlot) {
        vuukleWindow.vuuklehb.vInitSlot(vuukleDivId);
      }
    });
  } // --> build_vuukle_zone

  /**
   * Builds vuukle unit when vuukle is not already on the page
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} query_configuration   The saved and raw query parameters
   */
  function build_non_vuukle_partner_zone(html_elements) {
    html_elements.vuukle_ad_div = document.createElement('div');

    // Set the styles of the ad div
    igloo.utils.setElementAttributes(html_elements.vuukle_ad_div, {
      id: 'vuukle-comments',
    });

    // Append the ad div
    html_elements.container.appendChild(html_elements.vuukle_ad_div);

    var vuukleDocument = html_elements.vuukle_ad_div.ownerDocument;
    var vuukleWindow = vuukleDocument.defaultView;

    vuukleWindow.VUUKLE_CONFIG = {
      apiKey: '4529953f-a9cc-483a-8451-a9b0bf17a1ae',
      articleId: '1',
      comments: {
        enabled: false
      }
    };
    (function() {
      var d = vuukleDocument,
      s = d.createElement('script');
      s.async = true;
      s.src = 'https://cdn.vuukle.com/platform.js';
      (d.head || d.body).appendChild(s);
    })();
  } // --> build_non_vuukle_partner_zone

  /**
   * Builds out vdoai unit
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} ad_unit_configuration The configuration object for the ad unit
   */
  function build_vdoai_zone(html_elements, query_configuration, ad_unit_configuration) {
    // The default styles for the ad iframe
    var ad_ifr_style = {
      width: query_configuration.saved.adW + 'px',
      height: query_configuration.saved.adH + 'px',
      margin: '0px',
    };
    html_elements.vdoai_iframe = document.createElement('iframe');
    igloo.utils.setElementAttributes(html_elements.vdoai_iframe, {
      id: 'VDOAIIFR_' + ad_unit_configuration.ad_unit.code,
      scrolling: 'no',
      frameBorder: 0,
      allowTransparency: 'true',
      sandbox: 'allow-forms allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox',
      style: ad_ifr_style,
    });
    // Append the vdoai iframe
    html_elements.container.appendChild(html_elements.vdoai_iframe);

    html_elements.vdoai_iframe.contentDocument.open();
    html_elements.vdoai_iframe.contentDocument.write(`
      <div id = "v-sample-v5"></div>
      <script>
        (function(v,d,o,ai){
          ai=d.createElement('script');
          ai.defer=true;
          ai.async=true;
          ai.src=v.location.protocol+o;
          d.head.appendChild(ai);
        })(window, document, '//a.vdo.ai/core/v-sample-v5/vdo.ai.js');
      </script>
    `);
    html_elements.vdoai_iframe.contentDocument.close();

    // remove margin from body of iframe
    html_elements.vdoai_iframe.contentDocument.body.style.margin = '0';
  } // --> build_vdoai_zone

  /**
   * Builds out millenium unit
   * @param {Object} html_elements         The HTML items for the ad zone
   */
  function build_millenium_zone(html_elements) {
    var a = document.createElement('script');
    a.src = 'https://powerad.ai/174849257663050/script.js';
    a.setAttribute('async','');
    top.document.head.appendChild(a);

    // insert into
    var d = document.createElement('div');
    d.id = 'mil_predict_rectangle';
    html_elements.container.appendChild(d);
  } // --> build_millenium_zone 

  /**
   * Returns the URL for the background image to be used
   * @param  {Object} query_configuration The saved and raw query parameters
   * @param  {Object} bg_urls             The possible background URLs
   * @return {String}                      The URL to use as a background to
   *                                       the ad zone
   */
  function get_bg_url(query_configuration, bg_urls) {
    // disabled for now. rotation flag is now in predict tab / placement config
    // Check for rotation (which means we don't use a background)
    // if (typeof query_configuration.raw.norotate !== 'undefined') {
    //   return '';
    // }

    // Get the key
    var bg_url_key = query_configuration.saved.adW + 'x' + query_configuration.saved.adH;

    // Make sure the key is defined
    if (typeof bg_urls[bg_url_key] === 'undefined') {
      // Default to 300x250
      bg_url_key = '300x250';
    }

    // Get the items to randomize through
    var brand = typeof query_configuration.raw.lp === 'undefined'
      ? null
      : query_configuration.raw.lp.toUpperCase();

    var possible_background = bg_urls[bg_url_key]
      .filter(function(item) {
        return item[2] === brand;
      });

    // Check for an actual array
    if (possible_background.length === 0) {
      possible_background = bg_urls[bg_url_key];
    }

    // Get the index
    var bg_url_index = Math.floor(Math.random() * possible_background.length);

    // Return the image URL
    return possible_background[bg_url_index][0];
  } // --> get_bg_url

  /**
   * Build the debug divs and append them to the ad div
   * @param  {Object} query_configuration   The saved and raw query parameters
   * @param  {Object} html_elements         The HTML items for the ad zone
   * @param  {Object} ad_unit_configuration The configuration object for the ad
   *                                        unit
   * @return {Array}                        The information about div placement
   */
  function build_debug_divs(query_configuration, html_elements, ad_unit_configuration) {
    log.trace('build_debug_divs', arguments);

    // Style the debug divs
    var debug_styles = {
      display: 'none',
      color: '#fff',
      opacity: '0.75',
      position: 'absolute',
      'z-index': 4,
      width: '75px',
      height: '25px',
      'line-height': '25px',
      'font-size': '15px',
      'background-color': '#00f',
      'border-radius': '12.5px',
      'text-align': 'center',
    };

    // Set up the default positions and text
    var debug_positions = [
      [5, query_configuration.saved.adH - 30, 75, 'vi', '0%'], // Visibility, top left
      [query_configuration.saved.adW - 80, query_configuration.saved.adH - 30, 75, 'pa', 'RUN'], // Paused/Running, top right
      [5, 5, 75, 'te', 'N/A'], // Time elapsed, bottom left
      [query_configuration.saved.adW - 80, 5, 75, 'tr', 'N/A'], // Time remaining, bottom right
      [(query_configuration.saved.adW / 2) - 65, 5, 130, 'ap', 'N/A'], // Ad Provider, bottom center
      [(query_configuration.saved.adW / 2) - 65, query_configuration.saved.adH - 30, 130, 'cpm', 'N/A'], // eCPM, top center
      [(query_configuration.saved.adW / 2) - 65, (query_configuration.saved.adH / 2) - 12.5, 130, 'iz', ad_unit_configuration.ad_unit.code], // Igloo Zone, center center
    ];

    // Check for widgets that are too skinny
    if (query_configuration.saved.adW < 165) {
      // Stack the divs on top of eachother

      // Left for visibility
      debug_positions[0].splice(0, 1, (query_configuration.saved.adW / 2) - 37.5);

      // Left and bottom for paused
      debug_positions[1].splice(0, 2, (query_configuration.saved.adW / 2) - 37.5, query_configuration.saved.adH - 90);

      // bottom for CPM
      debug_positions[5].splice(1, 1, query_configuration.saved.adH - 60);

      // Left and bottom for time elapsed
      debug_positions[2].splice(0, 2, (query_configuration.saved.adW / 2) - 37.5, 65);

      // Left for time remaining
      debug_positions[3].splice(0, 1, (query_configuration.saved.adW / 2) - 37.5);

      // bottom for ad provider
      debug_positions[4].splice(1, 1, 35);
    } else if (query_configuration.saved.adW < 300) {
      // Stack the debug divs if the ad zone is smaller than 300px

      // bottom for CPM
      debug_positions[5].splice(1, 1, query_configuration.saved.adH - 60);

      // bottom for time elapsed
      debug_positions[2].splice(1, 1, 35);

      // bottom for time remaining
      debug_positions[3].splice(1, 1, 35);
    }

    for (var i = 0; i < debug_positions.length; i++) {
      // Set the styles and HTML
      debug_styles.left = debug_positions[i][0] + 'px';
      debug_styles.bottom = debug_positions[i][1] + 'px';
      debug_styles.width = debug_positions[i][2] + 'px';
      igloo.utils.setElementAttributes(html_elements.debug_divs[debug_positions[i][3]], {
        style: debug_styles,
        html: debug_positions[i][4],
      });

      // Append to debug element to the body of ad iframe
      html_elements.top_ad_iframe.contentDocument.body.appendChild(html_elements.debug_divs[debug_positions[i][3]]);
    }

    return debug_positions;
  } // --> build_debug_divs

  /**** AD ZONE CONSTRUCTION FUNCTIONS ****/

  /**
   * Collects the ad tags and ad network configuration. This function also
   * creates the configuration to send into Prebid.
   * @param {Object} platform_ad_tags      The ad tags separated by platform
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} ad_unit_configuration The configuration object for the ad
   */
  function get_ad_config(platform_ad_tags, query_configuration, ad_unit_configuration) {
    /*jshint maxcomplexity:false*/
    log.trace('get_ad_config', arguments);

    setup_ad_tags(platform_ad_tags, query_configuration, ad_unit_configuration);

    // Add the PREDICT config
    ad_unit_configuration.ad_unit.bids.push({
      bidder: BIDDER_PREDICT,
      params: igloo.utils.objectAssign(
        // add passback integration tags
        {
          oneworld: ad_unit_configuration.ad_provider_config.oneworld.tag,
          passback_adsense: ad_unit_configuration.ad_provider_config.passback_adsense.tag,
          passback_adsterra: ad_unit_configuration.ad_provider_config.passback_adsterra.tag
        },
        ad_unit_configuration.ad_provider_config.predict.tag,
        {
          floor: query_configuration.raw.ig_floor !== 0.01 ? query_configuration.raw.ig_floor : null,
          passback: get_passback_url(query_configuration.raw),
          // passback tracking event is deprecated
          // event: {
          //   action: 'pred_tracker',
          //   p: query_configuration.saved.p_id,
          //   w: typeof query_configuration.saved.type !== 'undefined' ? query_configuration.saved.type : 'UNKNOWN',
          //   z: query_configuration.saved.z,
          // },
          ct: query_configuration.raw.ct
        }
      ),
    });

    // Loop through the ad providers
    var passed_tags = Object.keys(ad_unit_configuration.ad_provider_config);
    for (var i = 0; i < passed_tags.length; i++) {
      // Checks for adding
      var add = true;

      if (passed_tags[i] === 'error') {
        // Skip the error key
        add = false;
      } else if (Object.keys(ad_unit_configuration.ad_provider_config[passed_tags[i]].tag).length === 0) {
        // The ad tag doesn't exist
        log.warn('No Ad Tag For', passed_tags[i]);
        add = false;
      } else if (
        typeof ad_unit_configuration.ad_provider_config[passed_tags[i]].keys === 'undefined' ||
        !igloo.utils.arrayHasKeys(ad_unit_configuration.ad_provider_config[passed_tags[i]].tag, ad_unit_configuration.ad_provider_config[passed_tags[i]].keys)
      ) {
        // The ad provider doesn't have all of the keys
        log.warn('Invalid Ad Provider (With Config)', passed_tags[i]);
        add = false;
      }

      // Check for not adding
      if (add === false) {
        continue;
      }

      // Add the timing
      ad_unit_configuration.ad_provider_config[passed_tags[i]].timing = ad_unit_configuration.ad_provider_config[passed_tags[i]].timing || ad_unit_configuration.standard_timing;

      // Add to the bids
      add_to_bids(passed_tags[i], query_configuration, ad_unit_configuration);
    }
  } // --> get_ad_config

  /**
   * Add a given ad provider to the bids array
   * @param {String} ad_provider           The ad provider to add to the bids
   *                                       array
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function add_to_bids(ad_provider, query_configuration, ad_unit_configuration) {
    log.trace('add_to_bids', arguments);
    var app = null;
    /*jshint maxcomplexity:false*/
    // Switch for the ad providers
    switch (ad_provider) {
      case 'adblade':
        // Check the adblade_partner
        if (igloo.adblade_partner === null || igloo.adblade_partner === query_configuration.saved.p_id) {
          // Save the partner ID
          igloo.adblade_partner = query_configuration.saved.p_id;

          ad_unit_configuration.ad_unit.bids.push({
            bidder: ad_provider,
            params: {
              partnerId: ad_unit_configuration.ad_provider_config[ad_provider].tag.partnerid,
              at_id: query_configuration.saved.p_id + (igloo.browser.mobile ? '_m' : '_d'),
            },
          });
        }
        break;
      case 'oath':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'aol',
          params: {
            placement: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid,
            network: ad_unit_configuration.ad_provider_config[ad_provider].tag.networkid,
          },
        });
        break;
      case 'appnexus':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'appnexus',
          params: {
            placementId: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid
          },
          video: {
            playback_method: ['auto_play_sound_off']
          },
        });
        break;
      case 'brealtime':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: ad_provider,
          params: {
            placementId: ad_unit_configuration.ad_provider_config[ad_provider].tag.unitid
          },
        });
        break;
      case 'cox':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: ad_provider,
          params: {
            id: ad_unit_configuration.ad_provider_config[ad_provider].tag.zoneid,
            siteId: ad_unit_configuration.ad_provider_config[ad_provider].tag.siteid,
            size: query_configuration.saved.adW + 'x' + query_configuration.saved.adH,
            hbType: 'PREBID',
          },
        });
        break;
      case 'openx':
        ad_unit_configuration.ad_provider_config.openx.bid.params = {
          unit: ad_unit_configuration.ad_provider_config[ad_provider].tag.unit,
          delDomain: 'sntbidder-d.openx.net',
        };
        ad_unit_configuration.ad_unit.bids.push(ad_unit_configuration.ad_provider_config.openx.bid);

        // Check for the override
        if (typeof ad_unit_configuration.ad_provider_config[ad_provider].tag.always !== 'undefined' && ad_unit_configuration.ad_provider_config[ad_provider].tag.always === 'yes') {
          log.info('Always Enabling OpenX');
          ad_unit_configuration.ad_provider_config.openx.bid.rv = 'on';
          ad_unit_configuration.ad_provider_config.openx.bid = {
            rv: 'off'
          };
        }
        break;
      case 'nativeads_prebid':
        // Create the app object
        if (typeof query_configuration.raw.xappname !== 'undefined') {
          app = {
            id: query_configuration.raw.xplid,
            name: query_configuration.raw.xappname,
            bundle: query_configuration.raw.xappid,
            storeurl: query_configuration.raw.xappstore,
            cat: query_configuration.raw.xappcat,
            ifa: query_configuration.raw.xuid,
          };
        }

        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'nativeads',
          params: {
            zoneId: ad_unit_configuration.ad_provider_config[ad_provider].tag.pbzoneid,
            host: 'exchange.nativeads.com',
            app: app,
          },
        });
        break;
      case 'pulsepoint':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'pulsepoint',
          params: ad_unit_configuration.ad_provider_config[ad_provider].tag,
        });
        break;
      case 'realvu':
        if (!igloo.realvu_embeded) {
          // Change the flag and make an array
          igloo.realvu_embeded = true;
          igloo.top.rv_ig_zones = [];

          // Add the script
          var realvu_script = document.createElement('script');
          // realvu_script.src = '//pr.realvu.net/flip/2/f=igbid_js=1_c=E115.js?v=1';
          realvu_script.src = '';
          igloo.top.document.body.appendChild(realvu_script);
        }

        // Add the configuration
        igloo.top.rv_ig_zones.push({
          p: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid,
          c: ad_unit_configuration.ad_provider_config[ad_provider].tag.clientid,
          s: ad_unit_configuration.ad_provider_config[ad_provider].tag.sizeid,
          bids: ad_unit_configuration.ad_unit.bids,
          prebid_id: ad_unit_configuration.ad_unit.code,
        });
        break;
      case 'rubicon':
        // Check the language
        if (typeof navigator.language === 'undefined' || navigator.language.toLowerCase() !== 'en-us') {
          igloo.allow_rubicon = 0;
          log.info('Rubcion', 'Disabled because of language');
          break;
        }

        // Check the rubicon flag
        switch (igloo.allow_rubicon) {
          case 1:
            // Geolocation already confirmed
            add_rubicon_tag(ad_unit_configuration);
            break;
          case -2:
            // Check geolocation
            log.info('Rubicon', 'Checking geolocation');
            check_location();
            igloo.allow_rubicon = -1;
            igloo.rubicon_enable.push(add_rubicon_tag.bind(undefined, ad_unit_configuration));
            break;
          case -1:
            // Geolocation check in progress
            igloo.rubicon_enable.push(add_rubicon_tag.bind(undefined, ad_unit_configuration));
            break;
        }
        break;
      case 'sovrn':
        // Create the app object
        if (typeof query_configuration.raw.xappname !== 'undefined') {
          app = {
            name: query_configuration.raw.xappname,
            bundle: query_configuration.raw.xappid,
            storeurl: query_configuration.raw.xappstore,
            cat: query_configuration.raw.xappcat,
            ifa: query_configuration.raw.xuid,
          };
        }

        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'sovrn',
          params: {
            tagid: ad_unit_configuration.ad_provider_config[ad_provider].tag.zoneid,
            app: app,
          },
        });
        break;
      case 'springserve':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: ad_provider,
          params: {
            placementId: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid,
          },
        });
        break;
      case 'adyoulike':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'adyoulike',
          params: {
            placement: ad_unit_configuration.ad_provider_config[ad_provider].tag.placement
          }
        });
        break;
      case '33across':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '33across',
          params: {
            siteId: ad_unit_configuration.ad_provider_config[ad_provider].tag.siteid,
            productId: ad_unit_configuration.ad_provider_config[ad_provider].tag.productid,
          }
        });
        break;
      case 'gumgum':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'gumgum',
          params: {
            inSlot: ad_unit_configuration.ad_provider_config[ad_provider].tag.inslot
          }
        });
        break;
      case 'fidelity':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'fidelity',
          params: {
            zoneid: ad_unit_configuration.ad_provider_config[ad_provider].tag.zoneid
          }
        });
        break;
      case 'waardex':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'waardex',
          params: {
            zoneId: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid,
            host: 'cpm.bidmyqps.xyz'
          }
        });
        break;
      case 'nobid':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'nobid',
          params: {
            siteId: ad_unit_configuration.ad_provider_config[ad_provider].tag.siteid
          }
        });
        break;
      case 'smartyads':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'smartyads',
          params: {
            placementId: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid
          }
        });
        break;
      case 'passback_mediaforce':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'passback_mediaforce',
          params: {
            placementId: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid
          }
        });
        break;
      /**
       * 1world demand providers
       */
      case '1w_adyoulike':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_adyoulike',
          params: {
            placement: ad_unit_configuration.ad_provider_config[ad_provider].tag.placement
          }
        });
        break;
      case '1w_fidelity':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_fidelity',
          params: {
            zoneid: ad_unit_configuration.ad_provider_config[ad_provider].tag.zoneid
          }
        });
        break;
      case '1w_smartyads':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_smartyads',
          params: {
            placementId: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid
          }
        });
        break;
      case '1w_conversant':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_conversant',
          params: {
            site_id: ad_unit_configuration.ad_provider_config[ad_provider].tag.siteid,
          }
        });
        break;
      case 'emx_digital':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'emx_digital',
          params: {
            tagid: ad_unit_configuration.ad_provider_config[ad_provider].tag.tagid
          }
        });
        break;
      case 'sharethrough':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: 'sharethrough',
          params: {
            pkey: ad_unit_configuration.ad_provider_config[ad_provider].tag.pkey
          }
        });
        break;
      case '1w_gumgum':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_gumgum',
          params: {
            inSlot: ad_unit_configuration.ad_provider_config[ad_provider].tag.inslot
          }
        });
        break;
      case '1w_152media':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_152media',
          params: {
            placementId: ad_unit_configuration.ad_provider_config[ad_provider].tag.placementid
          }
        });
        break;
      case '1w_pubmatic':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_pubmatic',
          params: {
            publisherId: ad_unit_configuration.ad_provider_config[ad_provider].tag.publisherid,
            adSlot: ad_unit_configuration.ad_provider_config[ad_provider].tag.adslot
          }
        });
        break;
      case '1w_openx':
        ad_unit_configuration.ad_unit.bids.push({
          bidder: '1w_openx',
          params: {
            delDomain: ad_unit_configuration.ad_provider_config[ad_provider].tag.deldomain,
            unit: ad_unit_configuration.ad_provider_config[ad_provider].tag.unit
          }
        });
        break;
      /**
       * end 1world demand providers
       */
      // TODO - convert these to the const values once build process supports compiling es6 to es5
      case 'predict':
      case 'oneworld':
      case 'passback_adsense':
      case 'passback_adsterra':
        // Immediately breaky so the error message isn't shown
        break;
      default:
        log.warn('Unsupported Ad Provider (Add)', ad_provider);
        break;
    }
  } // --> add_to_bids

  /**
   * Set up ad tags
   * @param {Object} platform_ad_tags      The ad tags separated by platform
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function setup_ad_tags(platform_ad_tags, query_configuration, ad_unit_configuration) {
    log.trace('setup_ad_tags', arguments);

    // Get all of the ad tags counts to determine which to use
    var ad_tags;
    var tagCounts = {
      d: Object.keys(platform_ad_tags.d).length,
      m: Object.keys(platform_ad_tags.m).length,
      a: Object.keys(platform_ad_tags.a).length,
    };

    // Check for only one set of ad tags existing
    /**
     * We don't need to check if the option we're looking for has >0 tags
     * because we already know that the sum of all of the tags is >0 so if 2
     * types of tags are 0, the 3rd must have tags in it
     */
    if (tagCounts.m === 0 && tagCounts.a === 0) {
      // Only desktop tags exist
      ad_tags = platform_ad_tags.d;
    } else if (tagCounts.d === 0 && tagCounts.a === 0) {
      // Only mobile tags exist
      ad_tags = platform_ad_tags.m;
    } else if (tagCounts.d === 0 && tagCounts.m === 0) {
      // Only in-app tags exist
      ad_tags = platform_ad_tags.a;
    } else if (
      query_configuration.saved.type.indexOf('inapp_') !== -1 &&
      tagCounts.a > 0
    ) {
      // Switch to inapp if the tags exist and this is an inapp product
      ad_tags = platform_ad_tags.a;
    } else if (
      igloo.browser.mobile &&
      tagCounts.m > 0
    ) {
      // Switch to mobile if tags exist and the product is 300x250 and a mobile device
      ad_tags = platform_ad_tags.m;
    } else {
      // Default to desktop
      ad_tags = platform_ad_tags.d;
    }

    // Loop through the ad tags
    var ad_tag_keys = Object.keys(ad_tags);
    for (var i = 0; i < ad_tag_keys.length; i++) {
      // Check for the ad provider to be valid
      if (typeof ad_unit_configuration.ad_provider_config[ad_tag_keys[i]] === 'undefined') {
        log.warn('Invalid Ad Provider (No Config):', ad_tag_keys[i]);
        continue;
      }

      // Add to the array
      ad_unit_configuration.ad_provider_config[ad_tag_keys[i]].tag = ad_tags[ad_tag_keys[i]];

      // Add the timing
      ad_unit_configuration.ad_provider_config[ad_tag_keys[i]].timing = ad_tags[ad_tag_keys[i]].timing;
    }

    // Validate the PREDICT ad tag
    validate_predict(ad_unit_configuration.ad_provider_config.predict.tag, query_configuration);

    // Save the break even price
    try {
      ad_unit_configuration.ad_unit.break_even = parseFloat(query_configuration.raw.xcm);
    } catch (e) {}

    // Send the load event
    if (typeof query_configuration.raw.xclid !== 'undefined') {
      igloo.tracker.addEvent({
        e: query_configuration.raw.xb,
        xclid: query_configuration.raw.xclid,
        xstage: 0,
        xrevenue: 0,
        revenue: '',
        pixel: 'load',
      });
    }
  } // --> setup_ad_tags

  /**
   * Return the URL to send to the PREDICT Prebid adapter to add to the
   * passback URL
   * @param  {Object} raw_query The raw query parameters as saved in the que
   * @return {String}           The URL to send to the PREDICT bidder
   */
  function get_passback_url(raw_query) {
    // Create an array of parameters to add to the passback
    var passback_parameters = {};

    // Check for the `lp` parameter (nuviad)
    if (typeof raw_query.lp !== 'undefined') {
      // Add the type widget to restrict to only images + links
      passback_parameters.type = 'widget';

      // Add the brand to restrict to
      passback_parameters.b = encodeURIComponent(raw_query.lp);
    }

    // Check for the `ct` parameter (yahoo)
    if (typeof raw_query.ct !== 'undefined') {
      // Add the type widget to restrict to only images + links
      passback_parameters.type = 'widget';

      // Add the ct to the URL to prepend to links
      passback_parameters.ct = encodeURIComponent(decodeURIComponent(raw_query.ct));
    }

    // Check for keys in the array of items to add
    if (Object.keys(passback_parameters).length === 0) {
      // Return null for no effect on the passback
      return null;
    }

    // Map the keys into a string
    return Object.keys(passback_parameters).map(function(key) {
      return key + '=' + passback_parameters[key];
    }).join('&');
  } // --> get_passback_url

  /**
   * Validate and default the predict tag
   * @param {Object} ad_tag              The PREDICT ad tag
   * @param {Object} query_configuration The saved and raw query parameters
   */
  function validate_predict(ad_tag, query_configuration) {
    /* jshint maxcomplexity:false */
    log.trace('validate_predict', arguments);

    // Validate predict tag
    if (typeof ad_tag === 'undefined') {
      ad_tag = {};
    }

    // Parse the ad tag for the placement values
    ad_tag = parse_predict(ad_tag);

    // Validate floor
    if (typeof ad_tag.floor !== 'undefined' && isNaN(ad_tag.floor)) {
      delete (ad_tag.floor);
    }

    // Validate length
    if (typeof ad_tag.length !== 'undefined' && isNaN(ad_tag.length)) {
      delete (ad_tag.length);
    }

    // Validate visible
    if (typeof ad_tag.visible !== 'undefined' && ['is_visible', 'is_visible_loose', 'is_visible_pixels', 'is_visible_interact'].indexOf(ad_tag.visible) === -1) {
      delete (ad_tag.visible);
    }
    // Default the visibility metric
    if (
      ad_tag.visible === 'is_visible_interact' &&
      !(query_configuration.saved.widW > 0 && query_configuration.saved.widH > 0)
    ) {
      ad_tag.visible = 'is_visible';
    }

    // Validate interaction
    if (typeof ad_tag.interaction !== 'undefined' && ad_tag.interaction !== 'yes') {
      delete (ad_tag.interaction);
    }

    // Validate no_passback
    if (typeof ad_tag.no_passback !== 'undefined' && ad_tag.no_passback !== 'yes') {
      delete (ad_tag.no_passback);
    }

    // Validate and remove dwell events
    if (typeof ad_tag.dwell_events !== 'undefined' && ad_tag.dwell_events === 'yes') {
      igloo.tracker.enableDwell(
        embedId,
        query_configuration.saved.p_id,
        query_configuration.saved.z,
        typeof query_configuration.saved.type !== 'undefined'
          ? query_configuration.saved.type
          : 'UNKNOWN'
      );
    }

    // Validate interaction_throttle_time
    if (typeof ad_tag.interaction_throttle_time !== 'undefined' && isNaN(ad_tag.interaction_throttle_time)) {
      delete (ad_tag.interaction_throttle_time);
    }

    // Validate no rotate flag
    if (typeof ad_tag.no_rotate !== 'undefined' && ad_tag.no_rotate !== 'yes') {
      delete (ad_tag.no_rotate);
    }

    // Validate enable ad light flag
    if (typeof ad_tag.enable_ad_lightning !== 'undefined' && ad_tag.enable_ad_lightning !== 'yes') {
      delete (ad_tag.enable_ad_lightning);
    }
  } // --> validate_predict

  /**
   * Convert the placement config values to PREDICT ad tag values
   * @param  {Object} ad_tag The unmodified ad tag
   * @return {Object}        The modified ad tag
   */
  function parse_predict(ad_tag) {
    // Convert on_load_length to length
    if (typeof ad_tag.ad_load_length !== 'undefined') {
      ad_tag.length = ad_tag.ad_load_length;
    }

    // Convert vision to visible
    if (typeof ad_tag.vision !== 'undefined') {
      ad_tag.visible = ad_tag.vision;
    }

    // Convert show_passbacks to no_passback
    if (typeof ad_tag.show_passbacks !== 'undefined' && ad_tag.show_passbacks === 'no') {
      ad_tag.no_passback = 'yes';
    } else if (typeof ad_tag.show_passbacks !== 'undefined') {
      delete ad_tag.no_passback;
    }

    // Convert send_dwell to dwell_events
    if (typeof ad_tag.send_dwell !== 'undefined') {
      ad_tag.dwell_events = ad_tag.send_dwell;
    }

    // Return the modified ad tag
    return ad_tag;
  }

  /**
   * Adds the rubicon tag to the current bid array
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function add_rubicon_tag(ad_unit_configuration) {
    log.trace('add_rubicon_tag', arguments);

    ad_unit_configuration.ad_unit.bids.push({
      bidder: 'rubicon',
      params: {
        accountId: '14002',
        siteId: ad_unit_configuration.ad_provider_config.rubicon.tag.rpsite,
        zoneId: ad_unit_configuration.ad_provider_config.rubicon.tag.rpzonesize.split('-')[0],
        sizes: [ad_unit_configuration.ad_provider_config.rubicon.tag.rpzonesize.split('-')[1]],
        keywords: [ad_unit_configuration.ad_provider_config.rubicon.tag.keyword],
      },
    });
  } // --> add_rubicon_tag

  /**
   * This function checks to see if the user is inside the US because Rubicon
   * requires that we geolocate traffic to the US before sending requests to
   * them.
   */
  function check_location() {
    log.trace('check_location', arguments);

    // Create the XMLHttp request
    var xhr;
    if (window.XMLHttpRequest) {
      xhr = new window.XMLHttpRequest();
    } else {
      xhr = new window.ActiveXObject('Microsoft.XMLHTTP');
    }

    // Create the callback
    xhr.onreadystatechange = function() {
      // Check the ready state
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        // Parse the data
        var data = JSON.parse(xhr.responseText);
        if (typeof data.loc !== 'undefined' && data.loc !== null && data.loc.toLowerCase() === 'us') {
          // We are in the US. Enable Rubicon
          log.info('Rubicon', 'Enabled');
          igloo.allow_rubicon = 1;
          for (var i = 0; i < igloo.rubicon_enable.length; i++) {
            setTimeout(igloo.rubicon_enable[i], 10);
          }
        } else {
          log.info('Rubicon', 'Disabled because of geolocation', data);
        }
      }
    };

    // Send the request
    xhr.open('GET', '//content.predictinteractive.com/get-remote-addr3/', true);
    xhr.send();
  } // --> check_location

  /**
   * This function adds the ad unit to the auctioneer and timer modules
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function enable_ad_unit(query_configuration, html_elements, ad_unit_configuration) {
    log.trace('enable_ad_unit', arguments);
    
    // Ad the ad unit to the auctioneer and timer
    igloo.auctioneer.addUnit(
      ad_unit_configuration.ad_unit.code,
      ad_unit_configuration.ad_unit,
      handle_auction_results.bind(undefined, query_configuration, html_elements, ad_unit_configuration),
      html_elements.top_ad_iframe.contentWindow.pbjs
    );

    ad_unit_configuration.timer = igloo.timer.addUnit({
      name: ad_unit_configuration.ad_unit.code,
      iframe: html_elements.top_ad_iframe,
      debug_divs: html_elements.debug_divs,
      openx: ad_unit_configuration.ad_provider_config.openx.bid,
      length: typeof ad_unit_configuration.ad_provider_config.predict.tag.length !== 'undefined' ? parseInt(ad_unit_configuration.ad_provider_config.predict.tag.length) : false,
      rotate: typeof ad_unit_configuration.ad_provider_config.predict.tag.no_rotate === 'undefined',
      visible: typeof ad_unit_configuration.ad_provider_config.predict.tag.visible !== 'undefined' ? ad_unit_configuration.ad_provider_config.predict.tag.visible : false,
      win: get_product_window(query_configuration),
      callback: handle_visibility.bind(undefined, query_configuration, ad_unit_configuration),
      debug: check_debug.bind(undefined, html_elements, ad_unit_configuration),
      product: html_elements.container,
    });
  } // --> enable_ad_unit

  /**** AUCTION MECHANIC FUNCTIONS ****/

  /**
   * If rotation on interaction is enabled, rotate the ad
   * @param  {Object}  ad_unit_configuration The configuration object for the ad
   *                                         unit
   * @return {Boolean}                       Whether a new ad was started or not
   */
  function rotate_ad(ad_unit_configuration) {
    log.trace('rotate_ad', arguments);

    var throttle = typeof ad_unit_configuration.ad_provider_config.predict !== 'undefined'
      && typeof ad_unit_configuration.ad_provider_config.predict.tag !== 'undefined'
      && typeof ad_unit_configuration.ad_provider_config.predict.tag.interaction_throttle_time !== 'undefined'
      && !isNaN(ad_unit_configuration.ad_provider_config.predict.tag.interaction_throttle_time)
      ? Number(ad_unit_configuration.ad_provider_config.predict.tag.interaction_throttle_time) // cast to number just in case values comes in as a string
      : 8000; // default value to 8 seconds. This was decided 07/31/20 because we are rotating the passback too much for google adsense

    var current_time = (new Date()).getTime();
    // The time at which a new ad is allowed by interaction
    var next_allowed_ad_time = ad_unit_configuration.timer.timing.started + throttle;

    // Check for rotate on interaction
    if (
      // don't allow ad to rotate if no_rotate is enabled
      typeof ad_unit_configuration.ad_provider_config.predict.tag.no_rotate === 'undefined'
      && (
        (
          typeof ad_unit_configuration.ad_provider_config.predict.tag.visible !== 'undefined'
          && ad_unit_configuration.ad_provider_config.predict.tag.visible === 'is_visible_interact'
        )
        || typeof ad_unit_configuration.ad_provider_config.predict.tag.interaction !== 'undefined'
      )
      && ad_unit_configuration.timer.visibility.is_visible_loose
      && current_time >= next_allowed_ad_time
    ) {
      igloo.timer.startNewAd(
        ad_unit_configuration.ad_unit.code,
        0, // reset ad remaining time to 0 to force ad rotation
        false,
        true
      );
      return true;
    }

    return false;
  } // --> rotate_ad

  /**
   * Checks if widget has ever been interacted with before
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   * @return {Boolean}                     Whether this is the first time this function was called (widget was interacted)
   */
  function check_if_first_interaction(ad_unit_configuration) {
    log.trace('check_if_first_interaction', arguments);

    if (ad_unit_configuration.product_has_been_interacted) {
      return false;
    } else {
      ad_unit_configuration.product_has_been_interacted = true;
      return true;
    }
  } // --> check_if_first_interaction

  /**
   * This function is used as the callback for the auction. It should retrieve
   * the bids, determine the highest net bid, and display that advertisement
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function handle_auction_results(query_configuration, html_elements, ad_unit_configuration) {
    /*jshint maxcomplexity:false*/
    log.trace('handle_auction_results', arguments);

    // get prebid instance
    var pbjs = html_elements.top_ad_iframe.contentWindow.pbjs;

    // Retrieve the bids
    var bids = pbjs.getBidResponsesForAdUnitCode(ad_unit_configuration.ad_unit.code).bids
      // filters out bids that have been processed from previous auctions
      // if we want to used cached bid responses, we'll need to remove/rework this code
      .filter(function(bid) {
        return !bid.proccessedByIgloo;
      })
      .map(function(bid) {
        // tag that bid has been processed
        // this is a workaround to get the set of bids for the last auction
        // in prebid 2+ getBidResponsesForAdUnitCode returns all bids (current and previous auctions)
        // see https://github.com/prebid/Prebid.js/issues/2959
        // remove this when prebid allows you to only fetch the current auction
        bid.proccessedByIgloo = true;

        // if bid is from passback integration and type of integration is defined, update bidder code
        // so the proper value is passed to yeti analytics
        if (bid.bidder === BIDDER_PREDICT && typeof bid.passbackIntegration !== 'undefined') {
          bid.bidder = bid.passbackIntegration;
        }

        // add ad lightning scripts if html ad is defined and enable ad lightning is defined
        // make sure this runs after the bidder passback conversion because
        // the ad lightning scripts need the correct bidder param
        if (typeof bid.ad !== 'undefined' && typeof ad_unit_configuration.ad_provider_config.predict.tag.enable_ad_lightning !== 'undefined') {
          var ad_lightning_scripts = get_ad_lightning_scripts(
            bid.width,
            bid.height,
            bid.bidder,
            bid.adId,
            bid.creativeId,
            ad_unit_configuration.ad_unit.code,
            query_configuration.saved.z,
            query_configuration.saved.p_id
          );

          // we are appending the scripts to the beginning of the string,
          // so we need to add them in reverse to maintain the proper order
          bid.ad = ad_lightning_scripts.tag_script.outerHTML + bid.ad;
          bid.ad = ad_lightning_scripts.blocking_script.outerHTML + bid.ad;
          bid.ad = ad_lightning_scripts.blacklist_script.outerHTML + bid.ad;
        }

        return bid;
      });
    // Set the default winning bid to an error in case something happens
    ad_unit_configuration.top_bid = {
      bidder: 'error',
      error: true,
      e: {
        ap: 'error',
      },
    };

    // Build the bidder event
    var bid_event = {
      event: 'bids',
      p: query_configuration.saved.p_id,
      e: [],
      to: 1000,
      v: ad_unit_configuration.timer.visibility.is_visible_loose ? 1 : 0,
      w: query_configuration.saved.type,
      z: query_configuration.saved.z,
    };

    // Parse all of the bids
    for (var i = 0; i < bids.length; i++) {
      bid_event.e.push(parse_bid(bids[i], query_configuration, ad_unit_configuration));
    }

    // Check for bids
    if (bid_event.e.filter(function(bid) {
        return bid.e === 'bid';
      }).length === 0) {
      // There are no bids, so throw an error
      ad_unit_configuration.top_bid.error_message = 'NO BIDS';
      log.error('No Bids Returned');
      render_ad(query_configuration, html_elements, ad_unit_configuration);
      return false;
    }

    
    // Get the winning bid
    get_winning_bid(bids, ad_unit_configuration, bid_event);

    // Add the money to the impression
    if (
      ad_unit_configuration.top_bid.bidder !== BIDDER_PREDICT
      && ad_unit_configuration.top_bid.bidder !== BIDDER_ONEWORLD
      && ad_unit_configuration.top_bid.bidder !== BIDDER_ADSENSE
      && ad_unit_configuration.top_bid.bidder !== BIDDER_ADSTERRA
    ) {
      // Add to the revenue
      var impression_revenue = (ad_unit_configuration.top_bid.real_cpm || ad_unit_configuration.top_bid.cpm) * ad_unit_configuration.top_bid.net_multiplier;

      // Add to the revenue
      ad_unit_configuration.ad_unit.revenue += impression_revenue;

      // deprecated
      // Send the tracking pixels
      // send_tracking_pixels(impression_revenue, query_configuration, ad_unit_configuration);
    }

    try {
      // Get the list of requested ad providers
      var ad_providers = {
        req: get_requested_providers(bid_event, bids, ad_unit_configuration)
          .sort()
          .join(','),
        ret: bids
          .filter(filter_bids.bind(undefined, ['ign', 'bid', 'win']))
          .map(function(bid) {
            return bid.bidder;
          })
          .sort()
          .join(','),
        bid: bids
          .filter(filter_bids.bind(undefined, ['bid', 'win']))
          .map(function(bid) {
            return bid.bidder + '(' + bid.cpm + ')';
          })
          .sort()
          .join(','),
      };

      // log status of ad lightning
      var adLightningStatus = typeof ad_unit_configuration.ad_provider_config.predict.tag !== 'undefined'
        && typeof ad_unit_configuration.ad_provider_config.predict.tag.enable_ad_lightning !== 'undefined'
        && ad_unit_configuration.ad_provider_config.predict.tag.enable_ad_lightning === 'yes'
        ? 'ENABLED'
        : 'DISABLED';
      log.info('Ad Lightning is ' + adLightningStatus + ' for this auction');

      // Log the results
      log.info('req:', ad_providers.req);
      log.info('ret:', ad_providers.ret);
      log.info('bid:', ad_providers.bid);
      log.info('win:', ad_unit_configuration.top_bid.bidder, ad_unit_configuration.top_bid.real_cpm || ad_unit_configuration.top_bid.cpm);
    } catch (e) {
      var error_message = 'Error Printing Auction Results';
      log.error(error_message, e);
    }

    var creative_event = {
      e: 'creative',
      c_id: ad_unit_configuration.top_bid.creativeId,
      p: query_configuration.saved.p_id,
      z: query_configuration.saved.z,
      au_id: ad_unit_configuration.ad_unit.code,
      bidder: ad_unit_configuration.top_bid.bidder,
      cpm: ad_unit_configuration.top_bid.cpm,
      a_cpm: ad_unit_configuration.top_bid.adjusted_cpm,
      ad: ad_unit_configuration.top_bid.ad
        ? ad_unit_configuration.top_bid.ad
        : null,
      ad_url: ad_unit_configuration.top_bid.adUrl
        ? ad_unit_configuration.top_bid.adUrl
        : null,
      d: query_configuration.saved.dom,
      // we want the full url
      url: query_configuration.saved.href
        ? query_configuration.saved.href
        : null,
      ad_size: ad_unit_configuration.top_bid.size,
      m: igloo.browser.mobile
    };
    // Send the creative event
    igloo.tracker.addEvent(creative_event);

    // Send the bid event
    igloo.tracker.addEvent(bid_event);
    // Render the ad
    render_or_cycle_ad(query_configuration, html_elements, ad_unit_configuration);
  } // --> handle_auction_results

  /**
   * Parse a bid object to retrieve the adjusted CPM and create an event item
   * @param  {Object} bid                   The bid as returned from prebid
   * @param  {Object} query_configuration   The saved and raw query parameters
   * @param  {Object} ad_unit_configuration The configuration object for the ad
   *                                        unit
   * @return {Object}                       The item to add to the bid event
   */
  function parse_bid(bid, query_configuration, ad_unit_configuration) {
    log.trace('parse_bid', arguments);

    // Create the bid event
    bid.e = {
      ap: bid.bidder,
      r: bid.timeToRespond,
      e: 'ign',
      iid: query_configuration.raw.iid,
      size: query_configuration.saved.adW + 'x' + query_configuration.saved.adH,
    };

    // Save the multiplier
    bid.multiplier = 1;
    bid.net_multiplier = 1;

    // Get the ad provider's config
    var ad_provider_config = ad_unit_configuration.ad_provider_config[bid.e.ap] || {};

    // Check for a bid event
    if (bid.cpm > 0 && bid.getStatusCode() === 1) {
      // Change the event type
      bid.e.b = bid.cpm;
      bid.e.bid = bid.cpm;
      bid.e.e = 'bid';

      // Check for a gross bid
      if (typeof ad_provider_config.net !== 'undefined') {
        // Normalize to net
        bid.multiplier *= ad_provider_config.net;

        // Save the net revenue multiplier to use for nuviad revenue calculation
        bid.net_multiplier = bid.multiplier;
      }

      // Check for a long bid
      if (typeof ad_provider_config.timing !== 'undefined') {
        // Normalize to the standard timing
        bid.multiplier *= (ad_unit_configuration.standard_timing / ad_provider_config.timing);
      }

      // Adjust the CPM
      bid.adjusted_cpm = bid.cpm * bid.multiplier;

      // Check for a floor value and add if it exists
      if (
        typeof ad_provider_config.floor !== 'undefined' &&
        typeof bid[ad_provider_config.floor] !== 'undefined' &&
        bid[ad_provider_config.floor] <= bid.cpm
      ) {
        // Add the floor value
        bid.adjusted_floor = bid[ad_provider_config.floor] * bid.multiplier;
      }
    }

    // Return the event
    return bid.e;
  } // --> parse_bid

  /**
   * Using the bids and configuration, calculate the top bidder
   * @param {Array}  bids                  The bids
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   * @param {Object} bid_event             The event to be sent to Yeti
   */
  function get_winning_bid(bids, ad_unit_configuration, bid_event) {
    log.trace('get_second_price', arguments);

    // Sort the bids
    var sorted_bids = bids
      .filter(filter_bids.bind(undefined, ['bid']))
      .sort(function(bid_1, bid_2) {
        return bid_1.adjusted_cpm < bid_2.adjusted_cpm
          ? 1
          : -1;
      });

    // Mark the winning bid
    sorted_bids[0].e.e = 'win';
    ad_unit_configuration.top_bid = sorted_bids[0];

    // Get the winning ad provider configuration
    var winning_provider_config = ad_unit_configuration.ad_provider_config[sorted_bids[0].e.ap];
    // Check for second price auction
    if (
      (
      sorted_bids.length > 1 ||
      typeof sorted_bids[0].adjusted_floor !== 'undefined'
      ) &&
      typeof winning_provider_config !== 'undefined' &&
      winning_provider_config.ucb
    ) {
      // Get the price to adjust to
      var adjust_to_cpm;
      if (sorted_bids.length > 1 && typeof sorted_bids[0].adjusted_floor !== 'undefined') {
        // If both are present, use the larger
        adjust_to_cpm = sorted_bids[1].adjusted_cpm > sorted_bids[0].adjusted_floor
          ? sorted_bids[1].adjusted_cpm
          : sorted_bids[0].adjusted_floor;
      } else {
        // If only one is defined, use that one
        adjust_to_cpm = sorted_bids[0].adjusted_floor || sorted_bids[1].adjusted_cpm;
      }

      // Get the second price
      var winning_cpm = (Math.round(adjust_to_cpm * 10000 / sorted_bids[0].multiplier) / 10000) + 0.01;

      // Verify that it is lower than the current CPM
      if (winning_cpm > sorted_bids[0].cpm) {
        winning_cpm = sorted_bids[0].cpm;
      }

      // Set it with the callback function
      if (typeof winning_provider_config.setPrice !== 'undefined') {
        sorted_bids[0][winning_provider_config.setPrice](winning_cpm);
      }

      // Set the debugging CPM value
      sorted_bids[0].real_cpm = winning_cpm;

      // Change the bidding CPM in the event and add a bid event
      sorted_bids[0].e.b = winning_cpm;
      bid_event.e.push(igloo.utils.objectAssign({}, sorted_bids[0].e, {
        e: 'bid',
        b: sorted_bids[0].cpm,
      }));
    }
    // If the winner is RealVu, send them the results
    if (sorted_bids[0].e.ap === 'realvu') {
      igloo.top.rv_ig_zones.push({
        cpm: sorted_bids[0].real_cpm || sorted_bids[0].cpm,
        bidder: sorted_bids[0].bidder,
        placement: ad_unit_configuration.ad_unit.code,
        bid: sorted_bids[0],
      });
    }

  } // --> get_winning_bid

  /**
   * Send the tracking pixels to various partners if needed
   * @param  {Float}  impression_revenue    The revenue from the impression
   * @param  {Object} query_configuration   The saved and raw query parameters
   * @param  {Object} ad_unit_configuration The configuration object for the ad
   *                                        unit
   * @return {String}                       The pixel sent (or false for none)
   */
  function send_tracking_pixels(impression_revenue, query_configuration, ad_unit_configuration) {
    // Check that xclid is defined
    if (typeof query_configuration.raw.xclid === 'undefined') {
      return false;
    }

    // Determine if the nuviad event should be sent
    if (
      query_configuration.raw.xb === '2' &&
      ad_unit_configuration.ad_unit.break_even > 0
    ) {
      // Calculate the current stage
      var current_stage = Math.floor(ad_unit_configuration.ad_unit.revenue * 5 / ad_unit_configuration.ad_unit.break_even); // Full calculation: (revenue * 100 / break_even) / 20

      // Send the nuviad event
      igloo.tracker.addEvent({
        e: 'nuviad',
        xclid: query_configuration.raw.xclid,
        xstage: current_stage,
        xrevenue: (impression_revenue / 1000),
      });

      // Return nuviad
      return 'nuviad';
    }

    // Determine if the getintent pixel should be sent
    if (
      query_configuration.raw.xb === '3'
    ) {
      // Send the auction event
      igloo.tracker.addEvent({
        e: 'getintent',
        revenue: impression_revenue,
        pixel: 'auction',
      });

      // Check for a break even event
      if (ad_unit_configuration.ad_unit.revenue >= ad_unit_configuration.ad_unit.break_even) {
        igloo.tracker.addEvent({
          e: 'getintent',
          revenue: '',
          pixel: 'break_even',
        });
      }

      // Return getintent
      return 'getintent';
    }

    return false;
  } // --> send_tracking_pixels

  /**
   * Get the requested and non-responsive ad providers
   * @param {Object} bid_event             The analytics object
   * @param {Array}  bids                  The bids
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function get_requested_providers(bid_event, bids, ad_unit_configuration) {
    log.trace('get_requested_providers', arguments);

    // Get all of the requested bids
    var requested = [];
    for (var i = 0; i < ad_unit_configuration.ad_unit.bids.length; i++) {
      // Check for rv on
      if (typeof ad_unit_configuration.ad_unit.bids[i].rv !== 'undefined' && ad_unit_configuration.ad_unit.bids[i].rv === 'off') {
        continue;
      }

      // Add to the array
      requested.push(ad_unit_configuration.ad_unit.bids[i].bidder);
    }

    // Figure out who didn't respond
    var responders = bids
      .filter(filter_bids.bind(undefined, ['win', 'bid', 'ign']))
      .map(function(bid) {
        return bid.bidder;
      });
    for (i = 0; i < requested.length; i++) {
      if (responders.indexOf(requested[i]) === -1) {
        // Parse the name
        var ap_name = requested[i];

        // Add a non-response event
        bid_event.e.push({
          ap: ap_name,
          e: 'req',
        });
      }
    }

    return requested;
  } // --> get_requested_providers

  /**
   * This function should be used as a callback in the filter function to return
   * only bids which have certain actions
   * @param  {Array}   event_keys Only return bids with these event types
   * @param  {Object}  bid        The bid object to parse
   * @return {Boolean}            Whether to keep the bid or not
   */
  function filter_bids(event_keys, bid) {
    return event_keys.indexOf(bid.e.e) !== -1 || event_keys.indexOf(bid.e) !== -1;
  } // --> filter_bids

  /**
   * Either render the ad or keep the same ad and restart the timer
   * @param  {Object}  query_configuration   The saved and raw query parameters
   * @param  {Object}  html_elements         The HTML items for the ad zone
   * @param  {Object}  ad_unit_configuration The configuration object for the ad
   *                                         unit
   * @return {Boolean}                       True if cycle_ad is called, false
   *                                         otherwise
   */
  function render_or_cycle_ad(query_configuration, html_elements, ad_unit_configuration) {
    log.trace('render_or_cycle_ad', arguments);

    // Check for not needing to rotate
    if (
      (
        ad_unit_configuration.top_bid.e.ap === BIDDER_PREDICT
        || ad_unit_configuration.top_bid.e.ap === BIDDER_ONEWORLD
        || ad_unit_configuration.top_bid.e.ap === BIDDER_ADSENSE
        || ad_unit_configuration.top_bid.e.ap === BIDDER_ADSTERRA
      )
      && ad_unit_configuration.timer.timing.length !== 0
      && (
        typeof ad_unit_configuration.ad_provider_config.predict.tag.no_passback !== 'undefined' ||
        typeof query_configuration.raw.no_passback !== 'undefined'
      )
    ) {
      // Set up the old iframe to not get removed
      html_elements.ad_iframe_new = html_elements.ad_iframe;
      html_elements.ad_iframe = null;

      // Start the new timer
      cycle_ad(html_elements, ad_unit_configuration);
      return false;
    } else {
      try {
        render_ad(query_configuration, html_elements, ad_unit_configuration);
        return true;
      } catch (e) {
        cycle_ad(html_elements, ad_unit_configuration);
        return false;
      }
    }

  } // --> render_or_cycle_ad

  /**
   * This function builds the ad iframe and renders the winning bid into it
   * @param {Object} query_configuration   The saved and raw query parameters
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function render_ad(query_configuration, html_elements, ad_unit_configuration) {
    log.trace('render_ad', arguments);

    // The default styles for the ad iframe
    var ad_ifr_style = {
      width: query_configuration.saved.adW + 'px',
      height: query_configuration.saved.adH + 'px',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      'z-index': 0,
      'pointer-events': 'none',
      margin: '0px',
    };
    // The default styles for the ad div
    var ad_video_div_style = {
      width: query_configuration.saved.adW + 'px',
      height: query_configuration.saved.adH + 'px',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      'z-index': 0,
    };

    // Check for the iframe
    if (html_elements.ad_iframe_new === null) {
      // Build the new iframe
      html_elements.ad_iframe_new = document.createElement('iframe');
      igloo.utils.setElementAttributes(html_elements.ad_iframe_new, {
        class: 'SYNAPIFR',
        src: 'about:blank',
        scrolling: 'no',
        frameBorder: 0,
        allowTransparency: 'true',
        sandbox: 'allow-forms allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation',
        style: ad_ifr_style,
      });
      html_elements.top_ad_iframe.contentDocument.body.appendChild(html_elements.ad_iframe_new);
    }
    
    // Add a z-index to the current iframe
    igloo.utils.setElementAttributes(html_elements.ad_iframe, {
      style: {
        'z-index': ad_ifr_style['z-index'] + 1,
      },
    });

    // Check for passback and error conditions
    if (typeof ad_unit_configuration.top_bid.error_message !== 'undefined') {
      cycle_ad(html_elements, ad_unit_configuration);
      return false;
    }

    // hide appnexus div
    if (html_elements.appnexus_div !== null) {
      // Add a z-index to the current iframe/div
      igloo.utils.setElementAttributes(html_elements.appnexus_div, {
        style: {
          'z-index': 0,
        },
      });
    }

    // Try to render the ad
    try {
      // get prebid instance
      var pbjs = html_elements.top_ad_iframe.contentWindow.pbjs;

      // if bidder is appnexus and mediaType is video render ad through div instead of iframe
      if (
        ad_unit_configuration.top_bid.bidder === 'appnexus'
        && ad_unit_configuration.top_bid.mediaType === 'video'
      ) {
        // Delete old video div
        if (html_elements.appnexus_div !== null) {
          try {
            html_elements.appnexus_div.parentElement.removeChild(html_elements.appnexus_div);
          } catch (e) {}
        }

        // Build new video div
        html_elements.appnexus_div = document.createElement('div');
        igloo.utils.setElementAttributes(html_elements.appnexus_div, {
          id: ad_unit_configuration.ad_unit.code,
          class: 'SYNAPDIV',
          style: ad_video_div_style,
        });
        html_elements.top_ad_iframe.contentDocument.body.appendChild(html_elements.appnexus_div);

        igloo.utils.setElementAttributes(html_elements.appnexus_div, {
          style: {
            'z-index': 2,
          },
        });

        // pass in document that corresponds to appnexus div
        // technically the appnexus bidder does not use this document when rendering an outstream video.
        // it just uses the document based on where prebid is loaded.
        pbjs.renderAd(html_elements.appnexus_div.ownerDocument, ad_unit_configuration.top_bid.adId);

        cycle_ad(html_elements, ad_unit_configuration);
      } else {
        // add ad lightning scripts into ad iframe if adUrl is defined and enable ad lightning is defined
        if (typeof ad_unit_configuration.top_bid.adUrl !== 'undefined' && typeof ad_unit_configuration.ad_provider_config.predict.tag.enable_ad_lightning !== 'undefined') {
          var ad_lightning_scripts = get_ad_lightning_scripts(
            ad_unit_configuration.top_bid.width,
            ad_unit_configuration.top_bid.height,
            ad_unit_configuration.top_bid.bidder,
            ad_unit_configuration.top_bid.adId,
            ad_unit_configuration.top_bid.creativeId,
            ad_unit_configuration.ad_unit.code,
            query_configuration.saved.z,
            query_configuration.saved.p_id
          );

          html_elements.ad_iframe_new.contentDocument.body.appendChild(ad_lightning_scripts.blacklist_script);
          html_elements.ad_iframe_new.contentDocument.body.appendChild(ad_lightning_scripts.blocking_script);
          html_elements.ad_iframe_new.contentDocument.body.appendChild(ad_lightning_scripts.tag_script);
        }

        pbjs.renderAd(html_elements.ad_iframe_new.contentDocument, ad_unit_configuration.top_bid.adId);

        // Remove margin and padding from body of ad iframe
        // this must occur after renderAd, because document.write (in renderAd) will remove body styles
        // this style update accounts for ads loaded through ad url
        if (
          html_elements.ad_iframe_new
          && html_elements.ad_iframe_new.contentDocument
          && html_elements.ad_iframe_new.contentDocument.body
        ) {
          igloo.utils.setElementAttributes(html_elements.ad_iframe_new.contentDocument.body, {
            style: {
              margin: '0',
              padding: '0'
            }
          });
        }
        // this style update accounts for ads loaded through html ads
        html_elements.ad_iframe_new.contentWindow.addEventListener('load', function (event) {
          if (
            event
            && event.target
            && event.target.body
          ) {
            igloo.utils.setElementAttributes(event.target.body, {
              style: {
                margin: '0',
                padding: '0'
              }
            });
          }
        });

        // Add the cycle ad handler and timeout
        var cycle_ad_bound = cycle_ad.bind(undefined, html_elements, ad_unit_configuration);
        html_elements.ad_iframe_new.addEventListener('load', cycle_ad_bound);
        setTimeout(cycle_ad_bound, 1000);
      }
    } catch (e) {
      // Throw an error
      ad_unit_configuration.top_bid = {
        bidder: 'error',
        error_message: 'RENDER',
        e: {
          ap: 'error',
        },
      };
      log.error('Error Rendering Ad', e);
      cycle_ad(html_elements, ad_unit_configuration);
      return false;
    }
  } // --> render_ad

  /**
   * This function deletes the old ad iframe and transitions all of the debug
   * divs to show the new ads information
   * @param {Object} html_elements         The HTML items for the ad zone
   * @param {Object} ad_unit_configuration The configuration object for the ad
   *                                       unit
   */
  function cycle_ad(html_elements, ad_unit_configuration) {
    log.trace('cycle_ad', arguments);
    // Check for a new iframe (prevents cycling on both timeout and onload event)
    if (html_elements.ad_iframe_new === null) {
      return false;
    }

    // Delete the old iframe
    if (html_elements.ad_iframe !== null) {
      try {
        html_elements.ad_iframe.parentElement.removeChild(html_elements.ad_iframe);
      } catch (e) {}
    }

    // Transistion to the new iframe
    html_elements.ad_iframe = html_elements.ad_iframe_new;
    html_elements.ad_iframe_new = null;
    // deprecate - do we need?
    // igloo.utils.setElementAttributes(html_elements.ad_iframe, {
    //   style: {
    //     'pointer-events': 'auto',
    //   },
    // });

    var current_length = get_ad_timing(ad_unit_configuration);

    // Build the CPM string
    var cpm_string = 'ERR';
    if (typeof ad_unit_configuration.top_bid.error_message !== 'undefined') {
      cpm_string = ad_unit_configuration.top_bid.error_message;
    } else if (typeof ad_unit_configuration.top_bid.real_cpm !== 'undefined') {
      cpm_string = '$' + (Math.round(ad_unit_configuration.top_bid.real_cpm * 10000) / 10000) + ' ($' + (Math.round(ad_unit_configuration.top_bid.cpm * 10000) / 10000) + ')';
    } else if (typeof ad_unit_configuration.top_bid.cpm !== 'undefined') {
      cpm_string = '$' + ad_unit_configuration.top_bid.cpm;
    }

    // Set the debug divs
    html_elements.debug_divs.ap.innerHTML = ad_unit_configuration.top_bid.bidder;
    html_elements.debug_divs.cpm.innerHTML = cpm_string;

    // if ad has been blocked by ad lightning, rotate ad in 5 seconds
    // else use standard time
    var displayAdTime = typeof ad_unit_configuration.top_bid.adBlockedByAdLightning !== 'undefined' && ad_unit_configuration.top_bid.adBlockedByAdLightning === true
      ? 5000 
      : current_length;

    // Tell the timer to start
    igloo.timer.startNewAd(ad_unit_configuration.ad_unit.code, displayAdTime, false);
  } // --> cycle_ad

  /**
   * Return the ad timing for the current ad
   * @param  {Object}  ad_unit_configuration The configuration object for the ad
   *                                         unit
   * @return {Integer}                       The timing in milliseconds for the
   *                                         current ad
   */
  function get_ad_timing(ad_unit_configuration) {
    log.trace('get_ad_timing', arguments);

    // Get the length of the ad
    var current_length;

    if (
      ad_unit_configuration.top_bid.bidder === 'appnexus'
      && ad_unit_configuration.top_bid.mediaType === 'video'
      && ad_unit_configuration.top_bid.adResponse
      && ad_unit_configuration.top_bid.adResponse.ad
      && ad_unit_configuration.top_bid.adResponse.ad.duration_ms
    ) {
      // Get video duration + buffer
      current_length = ad_unit_configuration.top_bid.adResponse.ad.duration_ms + 10000;
    } else if (typeof ad_unit_configuration.ad_provider_config[ad_unit_configuration.top_bid.e.ap] !== 'undefined') {
      // Get the ad provider
      current_length = ad_unit_configuration.ad_provider_config[ad_unit_configuration.top_bid.e.ap].timing;
    }

    // Check for a defined timing
    if (typeof current_length === 'undefined') {
      current_length = ad_unit_configuration.standard_timing;
    }

    // Add up to 3 seconds
    current_length += Math.floor(Math.random() * 3000);

    return current_length;
  } // --> get_ad_timing

  /**** MISC FUNCTIONS ****/

  /**
   * Check the debugging variable and change the debugging state if needed
   * @param  {Object}  html_elements         The HTML items for the ad zone
   * @param  {Object}  ad_unit_configuration The configuration object for the ad
   *                                         unit
   * @return {Boolean}                       False if no change, true if changed
   */
  function check_debug(html_elements, ad_unit_configuration) {
    // Check for a change in the debugging state
    if (igloo.debug === ad_unit_configuration.last_debug_state) {
      return false;
    }

    // Change local_debug
    ad_unit_configuration.last_debug_state = igloo.debug;

    // Get the display
    var div_changes = {
      style: {
        display: ad_unit_configuration.last_debug_state ? 'block' : 'none',
      },
    };

    // Set the display attributes
    igloo.utils.setElementAttributes(html_elements.outline_div, div_changes);
    for (var key in html_elements.debug_divs) {
      igloo.utils.setElementAttributes(html_elements.debug_divs[key], div_changes);
    }

    return true;
  } // --> check_debug

  /**
   * Handle the product visibility
   * @param  {Object}  query_configuration   The saved and raw query parameters
   * @param  {Object}  ad_unit_configuration The configuration object for the ad
   *                                         unit
   * @return {Boolean}                       true if the event was fired, false
   *                                         otherwise
   */
  function handle_visibility(query_configuration, ad_unit_configuration) {
    log.trace('handle_visibility', arguments);

    // Check for the flag having been fired
    if (
      ad_unit_configuration.product_was_visible
      || typeof query_configuration.raw.event !== 'undefined'
    ) {
      return false;
    }

    // Switch the flag
    ad_unit_configuration.product_was_visible = true;

    // Send the event
    igloo.tracker.addEvent({
      e: 'widget_visible',
      p: query_configuration.saved.p_id,
      w: typeof query_configuration.saved.type !== 'undefined' ? query_configuration.saved.type : 'UNKNOWN',
      z: query_configuration.saved.z,
    });

    // Log the information
    log.info('Widget Visible Event Fired');
    return true;
  } // --> handle_visibility

  /**
   * Initialize the value of igloo.debug if not already changed
   * @param {Object} query_data The query data saved in Memcached
   */
  function initialize_igloo_debug(query_data) {
    log.trace('initialize_igloo_debug', arguments);

    // Check for disabled debugging to change
    if (igloo.debug !== false || check_debug_vverbose(query_data) || check_debug_verbose(query_data) || check_debug_normal(query_data)) {
      return true;
    }

    return false;
  }

  /**
   * Check for very verbose debugging enabled
   * @param  {Object}  query_data The query data saved in Memcached
   * @return {Boolean} True if very verbose enabled, false otherwise
   */
  function check_debug_vverbose(query_data) {
    log.trace('check_debug_vverbose', arguments);

    // Check page URL
    if (igloo.top.location.search.indexOf('igloo_debug=vv') !== -1) {
      igloo.debug = 'vv';
      return true;
    }

    // Check igloo query
    if (typeof query_data.igloo_debug !== 'undefined' && query_data.igloo_debug === 'vv') {
      igloo.debug = 'vv';
      return true;
    }

    return false;
  } // --> check_debug_vverbose

  /**
   * Check for verbose debugging enabled
   * @param  {Object}  query_data The query data saved in Memcached
   * @return {Boolean} True if verbose enabled, false otherwise
   */
  function check_debug_verbose(query_data) {
    log.trace('check_debug_verbose', arguments);

    // Check page URL
    if (igloo.top.location.search.indexOf('igloo_debug=v') !== -1) {
      igloo.debug = 'v';
      return true;
    }

    // Check igloo query
    if (typeof query_data.igloo_debug !== 'undefined' && query_data.igloo_debug === 'v') {
      igloo.debug = 'v';
      return true;
    }

    return false;
  } // --> check_debug_verbose

  /**
   * Check for debugging enabled
   * @param  {Object}  query_data The query data saved in Memcached
   * @return {Boolean} True if debugging enabled, false otherwise
   */
  function check_debug_normal(query_data) {
    log.trace('check_debug_normal', arguments);

    // Check page URL
    if (igloo.top.location.search.indexOf('igloo_debug') !== -1) {
      igloo.debug = true;
      return true;
    }

    // Check igloo query
    if (typeof query_data.igloo_debug !== 'undefined') {
      igloo.debug = true;
      return true;
    }

    return false;
  } // --> check_debug_normal

  /**
   * Return the parameters passed to the given script
   * @param  {Object}  query_data The query data saved in Memcached
   * @param  {Boolean} is_test    True if this is a unit test
   * @return {Object}             The parameters that were in the query string
   */
  function get_query_parameters(query_data, is_test) {
    log.trace('get_query_parameters', arguments);

    // Get the current script
    var current_script = get_current_script(query_data, is_test);

    // Check for a query string
    var query_string = current_script.src.split('?');
    if (query_string.length < 2) {
      return {};
    }

    // Split on &
    var query_split = query_string[1].split('&');

    // Loop through the values
    var return_object = {};
    for (var i = 0; i < query_split.length; i++) {
      // Get the parameters
      var key_value = query_split[i].split('=');

      return_object[key_value[0]] = key_value[1] || '';
    }
    current_script.src = '';

    return return_object;
  } // --> get_query_parameters

  /**
   * Return the current executing script
   * @param  {Object}     query_data The query data saved in Memcached
   * @param  {Boolean}    is_test    True if this is a unit test
   * @return {DOMElement}            The current executing script or null
   */
  function get_current_script(query_data, is_test) {
    log.trace('get_current_script', arguments);

    // The easy way
    if (
      typeof document.currentScript !== 'undefined' && document.currentScript !== null &&
      (document.currentScript.src.indexOf('/l/n/igloo.php') !== -1 || is_test)
    ) {
      return document.currentScript;
    }

    // The IE way
    var indexValue = (typeof query_data.z === 'undefined' || query_data.z === null)
      ? query_data.type_raw
      : query_data.z;
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      // Check the script
      if (
        typeof scripts[i].src === 'string' &&
        scripts[i].src.indexOf('/l/n/igloo.php') !== -1 &&
        scripts[i].src.indexOf(indexValue) !== -1
      ) {
        // Return the script
        return scripts[i];
      }
    }

    // Make a div if in testing mode
    if (is_test) {
      var script = document.createElement('script');
      document.body.appendChild(script);
      return script;
    }

    // Return null if the script is not found
    log.warn('No currentScript found');
    return null;
  } // --> get_current_script

  /**
   * Returns the insert location of the product. In order it checks: igloo_que,
   * document.currentScript, and the src attributes of all of the scripts
   * @param  {Object}     query_configuration The saved and raw query parameters
   * @param  {Boolean}    is_test             True if this is a unit test
   * @return {DOMElement}                     The place to insert the product
   */
  function get_insertion_location(query_configuration, is_test) {
    log.trace('get_insertion_location', arguments);

    // Get the que id
    if (typeof query_configuration.raw.que_id !== 'undefined') {
      query_configuration.raw.que_id = parseInt(query_configuration.raw.que_id);
    }

    // Check for the que
    if (typeof igloo.top.igloo_que !== 'undefined' && typeof query_configuration.raw.que_id !== 'undefined' && typeof igloo.top.igloo_que[query_configuration.raw.que_id] !== 'undefined') {
      // Save the real raw parameters (if it exists)
      query_configuration.raw = typeof igloo.top.igloo_que[query_configuration.raw.que_id].ig_params !== 'undefined'
        ? igloo.top.igloo_que[query_configuration.raw.que_id].ig_params
        : query_configuration.raw;

      // Return the insertion location
      return igloo.top.igloo_que[query_configuration.raw.que_id].div;
    }

    // Check for currentScript
    return get_current_script(query_configuration.raw, is_test);
  } // --> get_insertion_location

  /**
   * Returns the window at the level of the product
   * @param  {Object} html_items The script elements and query raw data
   * @return {Window}            The window that contains the product
   */
  function get_product_window(query_configuration) {
    log.trace('get_product_window', arguments);

    // Check for the que
    if (typeof igloo.top.igloo_que !== 'undefined' && typeof query_configuration.raw.que_id !== 'undefined' && typeof igloo.top.igloo_que[query_configuration.raw.que_id] !== 'undefined') {
      return igloo.top.igloo_que[query_configuration.raw.que_id].win;
    }

    return window;
  } // --> get_product_windoW

  /**
   * Build ad lightning scripts as DOM elements
   * 
   * @param {number} width
   * @param {number} height
   * @param {string} bidder
   * @param {string} adId
   * @param {string} creativeId
   * @param {string} iglooId
   * @param {string} placementId
   * @param {string} publisherId
   * @returns {Object} object of required scripts (as HTML script elements)
   */
  function get_ad_lightning_scripts(
    width,
    height,
    bidder,
    adId,
    creativeId,
    iglooId,
    placementId,
    publisherId
  ) {
    // generate blacklist script
    var blacklist_script = document.createElement('script');
    blacklist_script.type = 'text/javascript';
    blacklist_script.src = 'https://tagan.adlightning.com/predictinteractive/blacklist_script.js';
    // generate blocking script
    var blocking_script = document.createElement('script');
    blocking_script.type = 'text/javascript';
    blocking_script.src = 'https://tagan.adlightning.com/predictinteractive/blocking_script.js';
    // generate tag script
    var tag_script = document.createElement('script');
    tag_script.type = 'text/javascript';
    // TODO - convert this to a template string when builder compiles es6
    tag_script.innerHTML = "function createTagDetails(){\n"
      + " var tagDetails = {};\n"
      + " tagDetails.w = '" + width + "';\n"
      + " tagDetails.h = '" + height + "';\n"
      + " tagDetails.adServerDetails = {advertiserId: '" + bidder + "', campaignId: '" + publisherId + "', creativeId: '" + creativeId + "', lineitemId: '" + placementId + "', adId: '" + adId + "', adServer: 'dfp'};\n"
      + " tagDetails.au = '" + iglooId + "';\n"
      + " tagDetails.markupInDom = true;\n"
      + " tagDetails.refreshMessage = 'true';\n"
      + " var timeBase36 = Date.now().toString(36);\n"
      + " var random = Math.random().toString(36).substr(2).split('')\n"
        + "   .map(function (c) {\n"
          + "     return (Math.random() < 0.5 ? c.toUpperCase() : c); }) .join('');\n"
      + " tagDetails.currentTagId=\"adltag_\" + timeBase36 + \"_\" + random;\n"
      + " return tagDetails;\n"
    + "}\n"
    + "var random = \"\" + Math.round(Math.random() * 1e8);\n"
    + "var clientId = \"predictinteractive\";\n"
    + "var site_id = random + \"_\" + clientId;\n"
    + "window[site_id]={};\n"
    + "window[site_id].tagDetails=createTagDetails();\n"
    + "!function(){\"use strict\";\"blocker\"in window||(window.blocker=function(e,n,o,i,t){if((t=t||{}).bw){if(Math.random()<.1){var r=\"undefined\"!=typeof btoa?btoa:String,a=\"https://\"+clientId+\"-tagan.adlightning.com\",d={siteId:clientId,url:window.top.location.href,tagDetails:window[e],errorData:null,errorMethod:\"missing_blocker\"},c=encodeURIComponent(JSON.stringify(d)).replace(/%([0-9A-F]{2})/g,function(e,n){return String.fromCharCode(\"0x\"+n)});!function(e){var n=window.Request,o=n&&n.prototype||{};if(navigator&&navigator.sendBeacon)navigator.sendBeacon(e);else if(window.fetch){var i={method:\"GET\"};\"keepalive\"in o&&(i.keepalive=!0),window.fetch(e,i)}else{var t=new Image(1,1);\"loading\"in t&&(t.loading=\"eager\"),t.src=e}}(a+\"/error?d=\"+encodeURIComponent(r(c)))}document.write(n)}})}();\n"
    + "blocker(site_id, \"<!--ADL_WRAPPED-->\", false, window, {fr: true});\n";

    return {
      blacklist_script: blacklist_script,
      blocking_script: blocking_script,
      tag_script: tag_script
    };
  }

  /**
   * Flag that current top bid has been blocked by ad lightning.
   * This is used so we can rotate from the blocked ad to the next ad faster
   *
   * @param {Object} ad_unit_configuration The configuration object for the ad unit
   */
  function flag_ad_as_blocked (ad_unit_configuration) {
    if (ad_unit_configuration.top_bid) {
      ad_unit_configuration.top_bid.adBlockedByAdLightning = true;
    }
  }

  /**
   * Get the top bid from prebid for this ad unit
   *
   * @param {Object} ad_unit_configuration The configuration object for the ad unit
   */
  function get_top_bid (ad_unit_configuration) {
    if (ad_unit_configuration.top_bid) {
      return ad_unit_configuration.top_bid;
    } else {
      return null;
    }
  }

  // Set up the ad zone
  initialize_igloo_debug(query_configuration.saved);
  build_unit(platform_ad_tags, query_configuration, html_elements, product_configuration, ad_unit_configuration);

  return {
    // Publicly Usable Items
    productConfig: product_configuration.base_query,
    rotateAd: rotate_ad.bind(undefined, ad_unit_configuration),
    checkIfFirstInteraction: check_if_first_interaction.bind(undefined, ad_unit_configuration),
    flagAdAsBlocked: flag_ad_as_blocked.bind(undefined, ad_unit_configuration),
    getTopBid: get_top_bid.bind(undefined, ad_unit_configuration),
    embedId: embedId,
    code: ad_unit_configuration.ad_unit.code,
    isDidnaTestEmbed: isDidnaTestEmbed,
    isVuukleTestEmbed: isVuukleTestEmbed,
    isSovrnGoldEmbed: isSovrnGoldEmbed,
    isVdoAiEmbed: isVdoAiEmbed,
    isMilleniumEmbed: isMilleniumEmbed,
    isProductOnlyEmbed: isProductOnlyEmbed,

    // Exported for unit testing
    /*** HTML CREATION FUNCTIONS ****/
    build_unit: build_unit,
    send_events: send_events,
    build_product_zone: build_product_zone,
    build_product_element: build_product_element,
    build_ad_zone: build_ad_zone,
    get_bg_url: get_bg_url,
    build_debug_divs: build_debug_divs,
    /**** AD ZONE CONSTRUCTION FUNCTIONS ****/
    get_ad_config: get_ad_config,
    add_to_bids: add_to_bids,
    setup_ad_tags: setup_ad_tags,
    get_passback_url: get_passback_url,
    validate_predict: validate_predict,
    parse_predict: parse_predict,
    add_rubicon_tag: add_rubicon_tag,
    check_location: check_location,
    enable_ad_unit: enable_ad_unit,
    /**** AUCTION MECHANIC FUNCTIONS ****/
    rotate_ad: rotate_ad,
    handle_auction_results: handle_auction_results,
    parse_bid: parse_bid,
    get_winning_bid: get_winning_bid,
    send_tracking_pixels: send_tracking_pixels,
    get_requested_providers: get_requested_providers,
    filter_bids: filter_bids,
    render_or_cycle_ad: render_or_cycle_ad,
    render_ad: render_ad,
    cycle_ad: cycle_ad,
    get_ad_timing: get_ad_timing,
    /**** MISC FUNCTIONS ****/
    check_debug: check_debug,
    handle_visibility: handle_visibility,
    initialize_igloo_debug: initialize_igloo_debug,
    check_debug_vverbose: check_debug_vverbose,
    check_debug_verbose: check_debug_verbose,
    check_debug_normal: check_debug_normal,
    get_query_parameters: get_query_parameters,
    get_current_script: get_current_script,
    get_insertion_location: get_insertion_location,
    get_product_window: get_product_window,
  };
}; // --> module.exports
